webpackJsonp(["main"],{

/***/ "./public/assets/images/decorative/spinner-dark.png":
/*!**********************************************************!*\
  !*** ./public/assets/images/decorative/spinner-dark.png ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "spinner-dark.cd2d3e40.png";

/***/ }),

/***/ "./public/assets/images/decorative/spinner-light.png":
/*!***********************************************************!*\
  !*** ./public/assets/images/decorative/spinner-light.png ***!
  \***********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "spinner-light.02ab2b7a.png";

/***/ }),

/***/ "./public/assets/images/logos/search-by-algolia-light-background-8762ce8b.svg":
/*!************************************************************************************!*\
  !*** ./public/assets/images/logos/search-by-algolia-light-background-8762ce8b.svg ***!
  \************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "search-by-algolia-light-background-8762ce8b.9769190d.svg";

/***/ }),

/***/ "./public/assets/scripts/bootstrap.js":
/*!********************************************!*\
  !*** ./public/assets/scripts/bootstrap.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stimulus_polyfills__ = __webpack_require__(/*! @stimulus/polyfills */ "./node_modules/@stimulus/polyfills/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stimulus_webpack_helpers__ = __webpack_require__(/*! stimulus/webpack-helpers */ "./node_modules/stimulus/webpack-helpers.js");



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var application = __WEBPACK_IMPORTED_MODULE_1_stimulus__["a" /* Application */].start();

  var context = __webpack_require__(/*! ./controllers */ "./public/assets/scripts/controllers recursive \\.js$");

  application.load(Object(__WEBPACK_IMPORTED_MODULE_2_stimulus_webpack_helpers__["a" /* definitionsFromContext */])(context));
});

/***/ }),

/***/ "./public/assets/scripts/components/CaseStudies.js":
/*!*********************************************************!*\
  !*** ./public/assets/scripts/components/CaseStudies.js ***!
  \*********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(/*! qs */ "./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_components_SimpleHero__ = __webpack_require__(/*! ~/scripts/components/SimpleHero */ "./public/assets/scripts/components/SimpleHero.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_components_case_studies_CaseStudiesFeatured__ = __webpack_require__(/*! ~/scripts/components/case-studies/CaseStudiesFeatured */ "./public/assets/scripts/components/case-studies/CaseStudiesFeatured.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_components_case_studies_Articles__ = __webpack_require__(/*! ~/scripts/components/case-studies/Articles */ "./public/assets/scripts/components/case-studies/Articles.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var CaseStudies =
/*#__PURE__*/
function (_Component) {
  _inherits(CaseStudies, _Component);

  function CaseStudies(props) {
    var _this;

    _classCallCheck(this, CaseStudies);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CaseStudies).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getApplication", function (slug) {
      var applications = _this.props.applications;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = applications[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.slug === slug) {
            return item;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (value) {
      var search = Object(__WEBPACK_IMPORTED_MODULE_2_qs__["stringify"])({
        application: value
      }, {
        addQueryPrefix: true,
        arrayFormat: "repeat"
      });
      window.history.pushState({}, "", "".concat(window.location.pathname).concat(search));

      _this.load();
    });

    _this.state = {
      data: []
    };
    _this.load = _this.load.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.loadMore = _this.loadMore.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleScroll = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["throttle"])(_this.handleScroll.bind(_assertThisInitialized(_assertThisInitialized(_this))), 250);
    _this.ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    return _this;
  }

  _createClass(CaseStudies, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("popstate", this.load);
      window.addEventListener("scroll", this.handleScroll);
      this.load();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("popstate", this.load);
      window.removeEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var endpoint, _parse, slug, application, url, response, body, data, pagination;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = this.props.endpoint;
                _parse = Object(__WEBPACK_IMPORTED_MODULE_2_qs__["parse"])(window.location.search, {
                  ignoreQueryPrefix: true,
                  arrayFormat: "repeat"
                }), slug = _parse.application;
                this.setState({
                  loading: true,
                  application: slug
                });
                application = this.getApplication(slug);
                url = application ? "".concat(endpoint, "/").concat(application.id) : endpoint;
                _context.next = 7;
                return fetch(url);

              case 7:
                response = _context.sent;
                _context.next = 10;
                return response.json();

              case 10:
                body = _context.sent;
                data = body.data, pagination = body.meta.pagination;
                this.setState({
                  loading: false,
                  data: data,
                  pagination: pagination,
                  application: slug
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var _this$state = this.state,
          loading = _this$state.loading,
          pagination = _this$state.pagination;

      if (loading || !pagination || pagination.current_page === pagination.total_pages || !pagination.links || !pagination.links.next) {
        return;
      }

      var _this$ref$current$get = this.ref.current.getBoundingClientRect(),
          bottom = _this$ref$current$get.bottom;

      var _window = window,
          innerHeight = _window.innerHeight;

      if (bottom - innerHeight / 2 <= innerHeight) {
        this.loadMore();
      }
    }
  }, {
    key: "loadMore",
    value: function () {
      var _loadMore = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var next, response, body, data, pagination;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                next = this.state.pagination.links.next;
                this.setState({
                  loading: true
                });
                _context2.next = 4;
                return fetch(next);

              case 4:
                response = _context2.sent;
                _context2.next = 7;
                return response.json();

              case 7:
                body = _context2.sent;
                data = body.data, pagination = body.meta.pagination;
                this.setState(function (prevState) {
                  return {
                    loading: false,
                    data: [].concat(_toConsumableArray(prevState.data), _toConsumableArray(data)),
                    pagination: pagination
                  };
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadMore() {
        return _loadMore.apply(this, arguments);
      }

      return loadMore;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          pre = _this$props.pre,
          featured = _this$props.featured,
          applications = _this$props.applications;
      var _this$state2 = this.state,
          application = _this$state2.application,
          data = _this$state2.data,
          loading = _this$state2.loading,
          pagination = _this$state2.pagination;

      if (!data) {
        return null;
      }

      var showFeatured = !application;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        ref: this.ref
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__scripts_components_SimpleHero__["a" /* default */], {
        pre: pre,
        noFeatured: !showFeatured
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__scripts_components_case_studies_CaseStudiesFeatured__["a" /* default */], {
        showFeatured: showFeatured,
        featured: featured,
        applications: applications,
        application: this.getApplication(application),
        onChange: this.handleChange
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__scripts_components_case_studies_Articles__["a" /* default */], {
        pagination: pagination,
        data: data,
        loading: loading
      }));
    }
  }]);

  return CaseStudies;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(CaseStudies, "propTypes", {
  endpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pre: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  featured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  applications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
});

/* harmony default export */ __webpack_exports__["a"] = (CaseStudies);

/***/ }),

/***/ "./public/assets/scripts/components/DownloadButton.js":
/*!************************************************************!*\
  !*** ./public/assets/scripts/components/DownloadButton.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var DownloadButton =
/*#__PURE__*/
function (_Component) {
  _inherits(DownloadButton, _Component);

  function DownloadButton() {
    _classCallCheck(this, DownloadButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(DownloadButton).apply(this, arguments));
  }

  _createClass(DownloadButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          size = _this$props.size;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        href: url,
        className: "download-button download-button--blue"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "download-button__inner"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Download ZIP"), " -", " ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "download-button__size"
      }, size)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "download-button__icon"
      }));
    }
  }]);

  return DownloadButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DownloadButton.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (DownloadButton);

/***/ }),

/***/ "./public/assets/scripts/components/Dropdown.js":
/*!******************************************************!*\
  !*** ./public/assets/scripts/components/Dropdown.js ***!
  \******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(/*! classnames */ "./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DropdownOption__ = __webpack_require__(/*! ./DropdownOption */ "./public/assets/scripts/components/DropdownOption.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var CLASS_FOCUSED = "is-focused";
var CLASS_OPENED = "is-opened";
var CLASS_SELECT_SIMPLE = "is-select-simple";
var optionPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

var Dropdown =
/*#__PURE__*/
function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Dropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isOpen: false,
      isFocused: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (event) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(event.target.value);

        _this.setState({
          isOpen: false,
          isFocused: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickItem", function (value) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(value);
      }

      _this.setState({
        isOpen: false,
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function () {
      _this.setState({
        isFocused: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBlur", function () {
      _this.setState({
        isOpen: false,
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderOption", function (_ref) {
      var key = _ref.key,
          label = _ref.label,
          value = _ref.value;
      var _this$props = _this.props,
          current = _this$props.value,
          defaultOption = _this$props.defaultOption;
      var selected = (current ? current.value : defaultOption.value) === value;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DropdownOption__["a" /* default */], {
        key: key,
        label: label,
        value: value,
        selected: selected,
        onClick: _this.handleClickItem
      });
    });

    return _this;
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          defaultOption = _this$props2.defaultOption,
          options = _this$props2.options,
          simple = _this$props2.simple;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          isFocused = _this$state.isFocused;
      var value = this.props.value;

      if (!value) {
        value = defaultOption;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("dropdown", (_classNames = {}, _defineProperty(_classNames, CLASS_FOCUSED, isFocused), _defineProperty(_classNames, CLASS_SELECT_SIMPLE, simple), _classNames)),
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        tabIndex: 0
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", {
        value: value.value,
        onChange: this.handleChange,
        tabIndex: -1
      }, defaultOption && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
        value: defaultOption.value
      }, defaultOption.label), options.map(function (option) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
          key: option.key,
          value: option.value
        }, option.label);
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "dropdown__text",
        onClick: this.handleClick
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "dropdown__text-inner"
      }, value.label)), !simple && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({}, CLASS_OPENED, isOpen))
      }, this.renderOption(defaultOption), options.map(this.renderOption)));
    }
  }]);

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Dropdown, "propTypes", {
  defaultOption: optionPropType,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(optionPropType),
  value: optionPropType,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  simple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
});

/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),

/***/ "./public/assets/scripts/components/DropdownOption.js":
/*!************************************************************!*\
  !*** ./public/assets/scripts/components/DropdownOption.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownOption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(/*! classnames */ "./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var CLASS_OPTION_NOVALUE = "is-option-no-value";
var CLASS_OPTION_SELECTED = "is-option-selected";

var DropdownOption =
/*#__PURE__*/
function (_Component) {
  _inherits(DropdownOption, _Component);

  function DropdownOption() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DropdownOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DropdownOption)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          value = _this$props.value;

      if (onClick) {
        onClick(value);
      }
    });

    return _this;
  }

  _createClass(DropdownOption, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          label = _this$props2.label,
          value = _this$props2.value,
          selected = _this$props2.selected;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, _defineProperty(_classNames, CLASS_OPTION_NOVALUE, !value), _defineProperty(_classNames, CLASS_OPTION_SELECTED, selected), _classNames)),
        onClick: this.handleClick
      }, label);
    }
  }]);

  return DropdownOption;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(DropdownOption, "propTypes", {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});



/***/ }),

/***/ "./public/assets/scripts/components/LeftyRighty.js":
/*!*********************************************************!*\
  !*** ./public/assets/scripts/components/LeftyRighty.js ***!
  \*********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(/*! classnames */ "./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var LeftyRighty =
/*#__PURE__*/
function (_Component) {
  _inherits(LeftyRighty, _Component);

  function LeftyRighty() {
    _classCallCheck(this, LeftyRighty);

    return _possibleConstructorReturn(this, _getPrototypeOf(LeftyRighty).apply(this, arguments));
  }

  _createClass(LeftyRighty, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          direction = _this$props.direction,
          theme = _this$props.theme,
          url = _this$props.url,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          text = _this$props.text,
          button = _this$props.button,
          desc = _this$props.desc,
          imageUrl = _this$props.imageUrl,
          caption = _this$props.caption;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("lefty-righty", "lefty-righty--".concat(direction), "lefty-righty--".concat(theme))
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__image"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: "lefty-righty__image-hover",
        href: url,
        "aria-label": title
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__image-wrap"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__image-front",
        style: {
          backgroundImage: "url(".concat(imageUrl, ")")
        }
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__image-underlay"
      })), caption && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__image-caption"
      }, caption))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__content"
      }, subtitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__sub-title"
      }, subtitle), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__title"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, title)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__text"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "small"
      }, text)), desc && desc.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__desc"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, desc.map(function (_ref) {
        var label = _ref.label,
            value = _ref.value;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", {
          key: label
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null, label, ":"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null, value));
      })))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "lefty-righty__button"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("button", "button--hollow", "button--".concat(theme)),
        href: url
      }, button))));
    }
  }]);

  return LeftyRighty;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(LeftyRighty, "propTypes", {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["left", "right"]),
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["light", "dark"]),
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  subtitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  button: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  desc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })),
  imageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  caption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

_defineProperty(LeftyRighty, "defaultProps", {
  direction: "left",
  theme: "dark",
  button: "Learn more"
});

/* harmony default export */ __webpack_exports__["a"] = (LeftyRighty);

/***/ }),

/***/ "./public/assets/scripts/components/OpSelect.js":
/*!******************************************************!*\
  !*** ./public/assets/scripts/components/OpSelect.js ***!
  \******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_is_mobile__ = __webpack_require__(/*! ./../helpers/is-mobile */ "./public/assets/scripts/helpers/is-mobile.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var CLASS_FOCUSED = 'is-focused';
var CLASS_VALID = 'is-valid';
var CLASS_OPENED = 'is-opened';
var CLASS_HAS_VALUE = 'is-has-value';
var CLASS_OPTION_NOVALUE = 'is-option-no-value';
var CLASS_OPTION_SELECTED = 'is-option-selected';
var CLASS_SELECT_SIMPLE = 'is-select-simple';

var OpSelect =
/*#__PURE__*/
function () {
  function OpSelect(settings) {
    _classCallCheck(this, OpSelect);

    _defineProperty(this, "opened", false);

    _defineProperty(this, "search", {
      char: "",
      started: false,
      timeout: null,
      delay: 300
    });

    // Disable on Tablets & Mobile
    this.el = settings.el;
    this.text = document.createElement('div');
    this.text.classList.add(settings.textClass);
    this.textInner = document.createElement('div');
    this.textInner.classList.add(settings.textInnerClass);
    this.select = settings.select;
    this.onChangeCallback = settings.onChangeCallback || null;
    this.text.appendChild(this.textInner);
    this.el.appendChild(this.text);
    this.el.setAttribute('tabindex', '0');
    this.select.setAttribute('tabindex', '-1'); // Disable on Tablets & Mobile

    if (__WEBPACK_IMPORTED_MODULE_0__helpers_is_mobile__["a" /* isMobile */]) {
      this.initMobile();
    } else {
      this.initDesktop();
    }
  }

  _createClass(OpSelect, [{
    key: "initMobile",
    value: function initMobile() {
      this.el.classList.add(CLASS_SELECT_SIMPLE);
      this.onChangeMobile = this.onChangeMobile.bind(this);
      this.onFocus = this.onFocus.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.select.addEventListener('change', this.onChangeMobile);
      this.el.addEventListener("focus", this.onFocus);
      this.el.addEventListener('blur', this.onBlur);
      this.select.addEventListener("focus", this.onFocus);
      this.select.addEventListener('blur', this.onBlur);
      this.selectCurrentMobile();
    }
  }, {
    key: "initDesktop",
    value: function initDesktop() {
      var _this = this;

      this.ul = document.createElement('ul');
      this.el.appendChild(this.ul);
      this.items = [].slice.call(this.select.options).map(function (option, index) {
        var li = document.createElement('li');
        li.innerHTML = option.text;

        _this.ul.appendChild(li);

        if (!option.value) {
          li.classList.add(CLASS_OPTION_NOVALUE);
        }

        return {
          dom: li,
          index: index,
          value: option.value,
          text: option.text
        };
      });
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.onFocus = this.onFocus.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onKeydown = this.onKeydown.bind(this); // this.changeEvent = new Event('change');

      this.changeEvent = document.createEvent('Event');
      this.changeEvent.initEvent('change', true, true);
      this.selectCurrent();
      this.text.addEventListener("click", this.open);
      this.el.addEventListener("focus", this.onFocus);
      this.el.addEventListener('blur', this.onBlur);
      this.el.addEventListener('keydown', this.onKeydown);
      this.items.forEach(function (item) {
        item.dom.addEventListener("click", function (e) {
          return _this.clickItem(item.index);
        });
      });
      this.select.addEventListener('change', this.onChange);
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.focus();
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.unfocus();
      this.close();
    }
  }, {
    key: "onChangeMobile",
    value: function onChangeMobile() {
      this.selectCurrentMobile();
      this.onChangeCallback();
    }
  }, {
    key: "selectCurrentMobile",
    value: function selectCurrentMobile() {
      this.textInner.innerHTML = this.select.options[this.select.selectedIndex].text;
      this.el.classList.add(CLASS_HAS_VALUE);
    }
  }, {
    key: "onChange",
    value: function onChange() {
      this.selectCurrent();
      this.onChangeCallback();
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(e) {
      // Esc keydowm
      if (e.which === 27) {
        this.onEsc(e);
        return;
      } // input was 0-9 // input was a-z


      if (e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 65 && e.keyCode <= 90) {
        this.onChar(e);
        return;
      } // arrows


      if (e.which === 38 || e.which === 40) {
        this.onArrow(e);
        return;
      } // enter


      if (e.which === 13) {
        this.onEnter(e);
        return;
      }
    }
  }, {
    key: "onEsc",
    value: function onEsc(e) {
      e.preventDefault();
      this.close();
    }
  }, {
    key: "onChar",
    value: function onChar(e) {
      var _this2 = this;

      if (!this.search.started) {
        this.search.started = true;
      } else {
        window.clearTimeout(this.search.timeout);
      }

      this.search.timeout = window.setTimeout(function () {
        _this2.search.char = "";
        _this2.search.started = false;
      }, this.search.delay);
      this.search.char += e.key;
      this.searchChar();
    }
  }, {
    key: "onArrow",
    value: function onArrow(e) {
      if (!this.opened) {
        this.open();
        return;
      } // Up


      if (e.keyCode === 38) {
        this.select.selectedIndex = Math.max(this.select.selectedIndex - 1, 0);
        this.select.dispatchEvent(this.changeEvent);
        this.scrollToIndex(this.select.selectedIndex);
      } // Down
      else if (e.keyCode === 40) {
          this.select.selectedIndex = Math.min(this.select.selectedIndex + 1, this.items.length - 1);
          this.select.dispatchEvent(this.changeEvent);
          this.scrollToIndex(this.select.selectedIndex);
        }
    }
  }, {
    key: "onEnter",
    value: function onEnter(e) {
      e.preventDefault();

      if (!this.opened) {
        this.open();
      } else {
        this.close();
      }
    }
  }, {
    key: "searchChar",
    value: function searchChar() {
      if (this.search.char === "") return;

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].text.toLowerCase().startsWith(this.search.char.toLowerCase())) {
          // console.log(this.items[i].text);
          // this.select.selectedIndex = i;
          // this.select.dispatchEvent(this.changeEvent);
          this.scrollToIndex(i);
          break;
        }
      }
    }
  }, {
    key: "selectCurrent",
    value: function selectCurrent() {
      this.textInner.innerHTML = this.items[this.select.selectedIndex].text;
      this.el.classList.add(CLASS_HAS_VALUE); // Add class to selected option in dropdown

      for (var i = 0; i < this.items.length; i++) {
        this.items[i].dom.classList.remove(CLASS_OPTION_SELECTED);
      }

      this.items[this.select.selectedIndex].dom.classList.add(CLASS_OPTION_SELECTED);
    }
  }, {
    key: "clickItem",
    value: function clickItem(index) {
      this.select.selectedIndex = index;
      this.select.dispatchEvent(this.changeEvent);
      this.close();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.el.classList.add(CLASS_FOCUSED);
    }
  }, {
    key: "unfocus",
    value: function unfocus() {
      this.el.classList.remove(CLASS_FOCUSED);
    }
  }, {
    key: "open",
    value: function open() {
      if (this.opened) return;
      this.opened = true;
      this.ul.classList.add(CLASS_OPENED);
      this.scrollToIndex(this.select.selectedIndex);
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.opened) return;
      this.opened = false;
      this.ul.scrollTop = 0; // Important for Firefox

      this.ul.classList.remove(CLASS_OPENED);
    }
  }, {
    key: "scrollToIndex",
    value: function scrollToIndex(index) {
      if (!this.opened) return;
      this.ul.scrollTop = 0;
      var ulRect = this.ul.getBoundingClientRect();
      var liRect = this.items[index].dom.getBoundingClientRect();
      var scrollDist = liRect.top - ulRect.top - ulRect.height / 2 + liRect.height / 2;
      this.ul.scrollTop = scrollDist < 0 ? 0 : scrollDist;
    }
  }]);

  return OpSelect;
}();



/***/ }),

/***/ "./public/assets/scripts/components/ProductModal.js":
/*!**********************************************************!*\
  !*** ./public/assets/scripts/components/ProductModal.js ***!
  \**********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DownloadButton__ = __webpack_require__(/*! ./DownloadButton */ "./public/assets/scripts/components/DownloadButton.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var downloadsPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}));

var ProductModal =
/*#__PURE__*/
function (_Component) {
  _inherits(ProductModal, _Component);

  function ProductModal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ProductModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ProductModal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
      _this.props.onCrossClick();
    });

    return _this;
  }

  _createClass(ProductModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          image = _this$props.image,
          code = _this$props.code,
          name = _this$props.name,
          downloads = _this$props.downloads,
          familyDownloads = _this$props.familyDownloads,
          bundleSize = _this$props.bundleSize,
          bundleUrl = _this$props.bundleUrl;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal-overlay ".concat(active ? "is-active" : ""),
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal ".concat(active ? "is-active" : "")
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__wrap"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__container"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__head"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__title"
      }, "Product Kit"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__cross",
        onClick: this.handleClick
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__scroller"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__body"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__product"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__product-image"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, image && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: image,
        alt: code
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__product-content"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__product-code"
      }, code), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__product-desc"
      }, name))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__content"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "downloads-list downloads-list--dark"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "downloads-list__title"
      }, "Downloads"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "downloads-list__ul"
      }, downloads.map(function (download) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          key: download.id,
          className: "downloads-list__li"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "downloads-list__item"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "downloads-list__name"
        }, download.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "downloads-list__size"
        }, download.size), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
          href: download.url,
          className: "downloads-list__item-download"
        })));
      }))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__foot"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__list"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__list-title"
      }, "The full Product Kit includes all downloads listed above plus the following:"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "modal__list-ul"
      }, familyDownloads.map(function (download) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          key: "".concat(download.id, "-").concat(download.index),
          className: "li li--white"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "file-name"
        }, download.title));
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal__button"
      }, bundleUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DownloadButton__["a" /* default */], {
        url: bundleUrl,
        size: bundleSize
      }))))))));
    }
  }]);

  return ProductModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ProductModal, "propTypes", {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  downloads: downloadsPropType,
  familyDownloads: downloadsPropType,
  bundleSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bundleUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onCrossClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
});

_defineProperty(ProductModal, "defaultProps", {
  downloads: [],
  familyDownloads: []
});

/* harmony default export */ __webpack_exports__["a"] = (ProductModal);

/***/ }),

/***/ "./public/assets/scripts/components/Products.js":
/*!******************************************************!*\
  !*** ./public/assets/scripts/components/Products.js ***!
  \******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(/*! qs */ "./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_components_products_Container__ = __webpack_require__(/*! ~/scripts/components/products/Container */ "./public/assets/scripts/components/products/Container.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_components_products_SearchRow__ = __webpack_require__(/*! ~/scripts/components/products/SearchRow */ "./public/assets/scripts/components/products/SearchRow.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_components_products_ResultsRow__ = __webpack_require__(/*! ~/scripts/components/products/ResultsRow */ "./public/assets/scripts/components/products/ResultsRow.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var Products =
/*#__PURE__*/
function (_Component) {
  _inherits(Products, _Component);

  function Products(props) {
    var _this;

    _classCallCheck(this, Products);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Products).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "readUrl", function (search) {
      var searchState = {};
      var parsed = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(search, {
        ignoreQueryPrefix: true,
        arrayFormat: "repeat"
      });
      searchState.query = parsed.query;

      if (parsed.application || parsed.brand || parsed.ipRating) {
        searchState.refinementList = {};

        if (parsed.application) {
          searchState.refinementList["family.applications"] = parsed.application;
        }

        if (parsed.brand) {
          searchState.refinementList["family.brand"] = parsed.brand;
        }

        if (parsed.ipRating) {
          searchState.refinementList["family.ipRating"] = parsed.ipRating;
        }
      }

      if (parsed.category) {
        searchState.hierarchicalMenu = {};
        searchState.hierarchicalMenu["family.categories.lvl0"] = parsed.category;
      }

      if (parsed.availability) {
        searchState.menu = {};
        searchState.menu["availability"] = parsed.availability;
      }

      if (parsed.lumensMin || parsed.lumensMax) {
        searchState.range = {};
        var lumens = {};

        if (parsed.lumensMin) {
          lumens.min = parsed.lumensMin;
        }

        if (parsed.lumensMax) {
          lumens.max = parsed.lumensMax;
        }

        searchState.range.lumens = lumens;
      }

      return searchState;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handlePopState", function () {
      var searchState = _this.readUrl(window.location.search);

      _this.setState({
        searchState: searchState
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchStateChange", function (nextSearchState) {
      var THRESHOLD = 700;
      var newPush = Date.now();
      var search = nextSearchState ? _this.createUrl(nextSearchState) : "";

      if (_this.state.lastPush && newPush - _this.state.lastPush <= THRESHOLD) {
        window.history.replaceState(null, null, search);
      } else {
        window.history.pushState(null, null, search);
      }

      _this.setState({
        lastPush: newPush,
        searchState: nextSearchState
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "createUrl", function (searchState) {
      var query = searchState.query,
          refinementList = searchState.refinementList,
          hierarchicalMenu = searchState.hierarchicalMenu,
          menu = searchState.menu,
          range = searchState.range;
      var search = {};

      if (query) {
        search.query = query;
      }

      if (refinementList) {
        var application = refinementList["family.applications"],
            brand = refinementList["family.brand"],
            ipRating = refinementList["family.ipRating"];

        if (application) {
          search.application = application;
        }

        if (brand) {
          search.brand = brand;
        }

        if (ipRating) {
          search.ipRating = ipRating;
        }
      }

      if (hierarchicalMenu) {
        var category = hierarchicalMenu["family.categories.lvl0"];

        if (category) {
          search.category = category;
        }
      }

      if (menu) {
        var availability = menu.availability;

        if (availability) {
          search.availability = availability;
        }
      }

      if (range) {
        var lumens = range.lumens;

        if (lumens) {
          if (lumens.min) {
            search.lumensMin = lumens.min;
          }

          if (lumens.max) {
            search.lumensMax = lumens.max;
          }
        }
      }

      return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(search) ? window.location.pathname : "".concat(window.location.pathname, "?").concat(__WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(search, {
        arrayFormat: "repeat"
      }));
    });

    _this.state = {
      searchState: _this.readUrl(window.location.search)
    };
    return _this;
  }

  _createClass(Products, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.onpopstate = this.handlePopState;
    }
  }, {
    key: "render",
    value: function render() {
      var searchState = this.state.searchState;
      var _window$__ENV_DATA__ = window.__ENV_DATA__,
          ALGOLIA_APPLICATION_ID = _window$__ENV_DATA__.ALGOLIA_APPLICATION_ID,
          ALGOLIA_API_KEY = _window$__ENV_DATA__.ALGOLIA_API_KEY,
          ALGOLIA_PRODUCTS_INDEX_NAME = _window$__ENV_DATA__.ALGOLIA_PRODUCTS_INDEX_NAME;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["c" /* InstantSearch */], {
        appId: ALGOLIA_APPLICATION_ID,
        apiKey: ALGOLIA_API_KEY,
        indexName: ALGOLIA_PRODUCTS_INDEX_NAME,
        createUrl: this.createUrl,
        searchState: searchState,
        onSearchStateChange: this.handleSearchStateChange,
        root: {
          Root: __WEBPACK_IMPORTED_MODULE_3__scripts_components_products_Container__["a" /* default */]
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__scripts_components_products_SearchRow__["a" /* default */], {
        searchState: searchState
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__scripts_components_products_ResultsRow__["a" /* default */], null));
    }
  }]);

  return Products;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Products);

/***/ }),

/***/ "./public/assets/scripts/components/SectionWrapper.js":
/*!************************************************************!*\
  !*** ./public/assets/scripts/components/SectionWrapper.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(/*! classnames */ "./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var SectionWrapper =
/*#__PURE__*/
function (_Component) {
  _inherits(SectionWrapper, _Component);

  function SectionWrapper() {
    _classCallCheck(this, SectionWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(SectionWrapper).apply(this, arguments));
  }

  _createClass(SectionWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bgColor = _this$props.bgColor,
          children = _this$props.children,
          id = _this$props.id,
          bigSpacing = _this$props.bigSpacing,
          withButton = _this$props.withButton,
          noBottom = _this$props.noBottom,
          title = _this$props.title,
          centerTitle = _this$props.centerTitle,
          topRightComponent = _this$props.topRightComponent,
          buttonComponent = _this$props.buttonComponent;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
        id: id,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("section-wrapper", bgColor && "section-wrapper--bg-".concat(bgColor), {
          "section-wrapper--with-button": withButton,
          "section-wrapper--spacing-big": bigSpacing,
          "section-wrapper--no-bottom": noBottom
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "section-wrapper__inner"
      }, title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("section-wrapper__title", {
          "section-wrapper__title--center": centerTitle
        })
      }, title), topRightComponent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "section-wrapper__topright"
      }, topRightComponent), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "section-wrapper__content"
      }, children), buttonComponent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "section-wrapper__button"
      }, buttonComponent)));
    }
  }]);

  return SectionWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(SectionWrapper, "propTypes", {
  bgColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["grey", "white", "dark-blue", "blue", "grey-ink"]),
  bigSpacing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  withButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  noBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  centerTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  topRightComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  buttonComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
});

/* harmony default export */ __webpack_exports__["a"] = (SectionWrapper);

/***/ }),

/***/ "./public/assets/scripts/components/SimpleHero.js":
/*!********************************************************!*\
  !*** ./public/assets/scripts/components/SimpleHero.js ***!
  \********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(/*! classnames */ "./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var SimpleHero =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SimpleHero, _PureComponent);

  function SimpleHero() {
    _classCallCheck(this, SimpleHero);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleHero).apply(this, arguments));
  }

  _createClass(SimpleHero, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          pre = _this$props.pre,
          text = _this$props.text,
          noFeatured = _this$props.noFeatured;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("simple-hero", {
          "simple-hero--no-featured": noFeatured
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "simple-hero__musthead"
      }, pre && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "simple-hero__pre"
      }, pre), text && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "simple-hero__text"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, text))));
    }
  }]);

  return SimpleHero;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

_defineProperty(SimpleHero, "propTypes", {
  pre: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  noFeatured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
});

/* harmony default export */ __webpack_exports__["a"] = (SimpleHero);

/***/ }),

/***/ "./public/assets/scripts/components/body.js":
/*!**************************************************!*\
  !*** ./public/assets/scripts/components/body.js ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Body; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_BODY_DISABLED = 'is-scroll-disabled';

var Body =
/*#__PURE__*/
function () {
  _createClass(Body, null, [{
    key: "instance",
    value: function instance() {
      if (this._instance) return this._instance;
      return this._instance = new this();
    }
  }]);

  function Body() {
    _classCallCheck(this, Body);

    _defineProperty(this, "scrollDisabled", false);

    _defineProperty(this, "_instance", void 0);

    this.body = document.body;
  }

  _createClass(Body, [{
    key: "disableScroll",
    value: function disableScroll() {
      if (this.scrollDisabled) return;
      this.scrollDisabled = true;
      this.body.classList.add(CLASS_BODY_DISABLED);
    }
  }, {
    key: "enableScroll",
    value: function enableScroll() {
      if (!this.scrollDisabled) return;
      this.scrollDisabled = false;
      this.body.classList.remove(CLASS_BODY_DISABLED);
    }
  }]);

  return Body;
}();



/***/ }),

/***/ "./public/assets/scripts/components/case-studies/Articles.js":
/*!*******************************************************************!*\
  !*** ./public/assets/scripts/components/case-studies/Articles.js ***!
  \*******************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_components_SectionWrapper__ = __webpack_require__(/*! ~/scripts/components/SectionWrapper */ "./public/assets/scripts/components/SectionWrapper.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeftyRighty__ = __webpack_require__(/*! ../LeftyRighty */ "./public/assets/scripts/components/LeftyRighty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__products_Searching__ = __webpack_require__(/*! ../products/Searching */ "./public/assets/scripts/components/products/Searching.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Articles =
/*#__PURE__*/
function (_Component) {
  _inherits(Articles, _Component);

  function Articles() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Articles);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Articles)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderArticle", function (_ref, index) {
      var id = _ref.id,
          title = _ref.title,
          url = _ref.url,
          summary = _ref.summary,
          imageUrl = _ref.imageUrl,
          project = _ref.project,
          applications = _ref.applications;
      var direction = index % 2 ? "left" : "right";
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__scripts_components_SectionWrapper__["a" /* default */], {
        key: id,
        bgColor: "dark-blue",
        bigSpacing: true
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LeftyRighty__["a" /* default */], {
        direction: direction,
        theme: "light",
        url: url,
        title: title,
        text: summary,
        imageUrl: imageUrl,
        desc: [{
          label: "Project",
          value: project
        }, {
          label: "Applications",
          value: applications ? applications.join(", ") : ""
        }],
        button: "View case study"
      }));
    });

    return _this;
  }

  _createClass(Articles, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          loading = _this$props.loading,
          pagination = _this$props.pagination;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, data.map(this.renderArticle), loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__scripts_components_SectionWrapper__["a" /* default */], {
        bgColor: "dark-blue",
        bigSpacing: true
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__products_Searching__["a" /* default */], {
        theme: "light"
      })), !loading && pagination && pagination.total === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "no-results"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "no-results__message"
      }, "Sorry, there are no results that match your query.")));
    }
  }]);

  return Articles;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Articles, "propTypes", {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
});

/* harmony default export */ __webpack_exports__["a"] = (Articles);

/***/ }),

/***/ "./public/assets/scripts/components/case-studies/CaseStudiesFeatured.js":
/*!******************************************************************************!*\
  !*** ./public/assets/scripts/components/case-studies/CaseStudiesFeatured.js ***!
  \******************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(/*! classnames */ "./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_components_Dropdown__ = __webpack_require__(/*! ~/scripts/components/Dropdown */ "./public/assets/scripts/components/Dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_components_LeftyRighty__ = __webpack_require__(/*! ~/scripts/components/LeftyRighty */ "./public/assets/scripts/components/LeftyRighty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_is_mobile__ = __webpack_require__(/*! ../../helpers/is-mobile */ "./public/assets/scripts/helpers/is-mobile.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var CaseStudiesFeatured =
/*#__PURE__*/
function (_Component) {
  _inherits(CaseStudiesFeatured, _Component);

  function CaseStudiesFeatured() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CaseStudiesFeatured);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CaseStudiesFeatured)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (value) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(value);
      }
    });

    return _this;
  }

  _createClass(CaseStudiesFeatured, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showFeatured = _this$props.showFeatured,
          featured = _this$props.featured,
          applications = _this$props.applications,
          application = _this$props.application;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("casestudies-featured", {
          "casestudies-featured--no-featured": !showFeatured
        })
      }, showFeatured && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "casestudies-featured__body"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__scripts_components_LeftyRighty__["a" /* default */], {
        direction: "left",
        title: featured.title,
        subtitle: "Featured",
        text: featured.summary,
        url: featured.url,
        imageUrl: featured.imageUrl,
        button: "View case study",
        desc: [{
          label: "Project",
          value: featured.project
        }, {
          label: "Applications",
          value: featured.applications.join(", ")
        }]
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "casestudies-featured__head"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "casestudies-featured__filter"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__scripts_components_Dropdown__["a" /* default */], {
        simple: __WEBPACK_IMPORTED_MODULE_5__helpers_is_mobile__["a" /* isMobile */],
        defaultOption: {
          label: "Any application"
        },
        options: applications.map(function (application) {
          return {
            key: application.id,
            label: application.title,
            value: application.slug
          };
        }),
        value: application && {
          key: application.id,
          label: application.title,
          value: application.slug
        },
        onChange: this.handleChange
      }))));
    }
  }]);

  return CaseStudiesFeatured;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(CaseStudiesFeatured, "propTypes", {
  showFeatured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  featured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  applications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    slug: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })),
  application: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    slug: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }),
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

/* harmony default export */ __webpack_exports__["a"] = (CaseStudiesFeatured);

/***/ }),

/***/ "./public/assets/scripts/components/modal-overlay.js":
/*!***********************************************************!*\
  !*** ./public/assets/scripts/components/modal-overlay.js ***!
  \***********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalOverlay; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ATTR = "modal-overlay";
var CLASS_ACTIVE = "is-active";

var ModalOverlay =
/*#__PURE__*/
function () {
  _createClass(ModalOverlay, null, [{
    key: "instance",
    value: function instance() {
      if (this._instance) return this._instance;
      return this._instance = new this();
    }
  }]);

  function ModalOverlay(settings) {
    _classCallCheck(this, ModalOverlay);

    _defineProperty(this, "_clickCallbacks", []);

    _defineProperty(this, "active", false);

    _defineProperty(this, "_instance", void 0);

    this.onClick = this.onClick.bind(this);
    this.el = document.querySelector("[".concat(ATTR, "]"));
    this.el.addEventListener("click", this.onClick);

    if (settings) {
      if (typeof settings.onClick === "function") {
        this._clickCallbacks.push(settings.onClick);
      }
    }
  }

  _createClass(ModalOverlay, [{
    key: "onClick",
    value: function onClick() {
      var cb = this._clickCallbacks;

      for (var i = 0; i < cb.length; i++) {
        cb[i]();
      }
    }
  }, {
    key: "activate",
    value: function activate() {
      if (this.active) return;
      this.active = true;
      this.el.classList.add(CLASS_ACTIVE);
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      if (!this.active) return;
      this.active = false;
      this.el.classList.remove(CLASS_ACTIVE);
    }
  }]);

  return ModalOverlay;
}();



/***/ }),

/***/ "./public/assets/scripts/components/opSlider/_animation.js":
/*!*****************************************************************!*\
  !*** ./public/assets/scripts/components/opSlider/_animation.js ***!
  \*****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Animation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_AF__ = __webpack_require__(/*! ./../../helpers/AF */ "./public/assets/scripts/helpers/AF.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_bezier_easing__ = __webpack_require__(/*! ./../../helpers/bezier-easing */ "./public/assets/scripts/helpers/bezier-easing.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Animation =
/*#__PURE__*/
function () {
  function Animation(el) {
    _classCallCheck(this, Animation);

    _defineProperty(this, "type", 'drag');

    _defineProperty(this, "x", 0);

    _defineProperty(this, "xAnim", 0);

    _defineProperty(this, "stopped", true);

    _defineProperty(this, "_drag", {
      step: 0.12
    });

    _defineProperty(this, "_release", {
      progres: 0,
      duration: 1000,
      timeStart: null,
      xStart: 0,
      distance: 0,
      ease: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_bezier_easing__["a" /* default */])(0.135, 0.435, 0.12, 0.975)
    });

    this.el = el;
    this._write = this._write.bind(this);
    this._render = this._render.bind(this);
    this.af = __WEBPACK_IMPORTED_MODULE_0__helpers_AF__["a" /* default */].instance();
  }

  _createClass(Animation, [{
    key: "drag",
    value: function drag(x) {
      this.type = 'drag';
      this.x = x;

      this._start();
    }
  }, {
    key: "release",
    value: function release(x) {
      var _this = this;

      this.af.onNextWrite(function () {
        var r = _this._release;
        _this.type = 'release';
        _this.x = x;
        r.progress = 0;
        r.timeStart = window.performance.now();
        r.xStart = _this.xAnim;
        r.distance = _this.x - _this.xAnim;

        _this._start();
      });
    }
  }, {
    key: "jump",
    value: function jump(x) {
      var _this2 = this;

      this.af.onNextWrite(function () {
        _this2.x = x;
        _this2.xAnim = x;

        _this2._render();
      });
    }
  }, {
    key: "offset",
    value: function offset(x) {
      var _this3 = this;

      this.af.onNextWrite(function () {
        _this3.xAnim = _this3.xAnim - x;
      });
    }
  }, {
    key: "_write",
    value: function _write() {
      this._tick();

      this._render();
    }
  }, {
    key: "_render",
    value: function _render() {
      // console.log('_render');
      this.el.style.transform = 'translateX(' + this.xAnim + 'px)';
    }
  }, {
    key: "_tick",
    value: function _tick() {
      if (Math.abs(this.x - this.xAnim) < 1) {
        this._stop();

        return;
      }

      switch (this.type) {
        case 'drag':
          this.xAnim += (this.x - this.xAnim) * this._drag.step;
          break;

        case 'release':
          var r = this._release;

          if (r.progress < r.duration) {
            r.progress = Math.min(window.performance.now() - r.timeStart, r.duration);
            this.xAnim = r.xStart + r.distance * r.ease(r.progress / r.duration);
          } else {
            this._stop();
          }

          break;
      }
    }
  }, {
    key: "_start",
    value: function _start() {
      if (!this.stopped) return;
      this.stopped = false;
      this.af.addWrite(this._write);
    }
  }, {
    key: "_stop",
    value: function _stop() {
      if (this.stopped) return;
      this.stopped = true;
      this.af.removeWrite(this._write);
    }
  }]);

  return Animation;
}();



/***/ }),

/***/ "./public/assets/scripts/components/opSlider/_autoplay.js":
/*!****************************************************************!*\
  !*** ./public/assets/scripts/components/opSlider/_autoplay.js ***!
  \****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Autoplay; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Autoplay =
/*#__PURE__*/
function () {
  function Autoplay(config) {
    _classCallCheck(this, Autoplay);

    _defineProperty(this, "timer", null);

    _defineProperty(this, "stopped", true);

    _defineProperty(this, "initialised", false);

    if (typeof config.el === 'undefined') return;
    this._callback = config.callback;
    this._settings = config.settings;
    this.duration = this._settings.duration || 3000;
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.restart = this.restart.bind(this);
  }

  _createClass(Autoplay, [{
    key: "start",
    value: function start() {
      var _this = this;

      if (!this.initialised) return;
      if (!this.stopped) return; // console.log('start Autoplay');

      clearTimeout(this.timer);
      this.stopped = false;
      this.timer = setTimeout(function () {
        // console.log('callback Autoplay', this.duration);
        _this.stopped = true;

        _this._callback();

        _this.start();
      }, this.duration);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.initialised) return;
      if (this.stopped) return;
      this.stopped = true;
      clearTimeout(this.timer);
    }
  }, {
    key: "restart",
    value: function restart() {
      this.stop();
      this.start();
    }
  }]);

  return Autoplay;
}();



/***/ }),

/***/ "./public/assets/scripts/components/opSlider/_controls.js":
/*!****************************************************************!*\
  !*** ./public/assets/scripts/components/opSlider/_controls.js ***!
  \****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Controls; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_CONTROL_DISABLED = 'is-disabled';

var Controls =
/*#__PURE__*/
function () {
  function Controls(config) {
    _classCallCheck(this, Controls);

    _defineProperty(this, "initialisedNext", false);

    _defineProperty(this, "initialisedPrev", false);

    this._slider = config.slider;
    this.nextItems = config.nextItems;
    this.prevItems = config.prevItems;
    this._next = config.next;
    this._prev = config.prev;
    this.update = this.update.bind(this);
    this._handleKeydown = this._handleKeydown.bind(this);
    if (typeof this.nextItems !== 'undefined') this.initialisedNext = true;
    if (typeof this.prevItems !== 'undefined') this.initialisedPrev = true;

    if (this.initialisedNext) {
      for (var i = 0; i < this.nextItems.length; i++) {
        this.nextItems[i].addEventListener('click', this._next);
      }
    }

    if (this.initialisedPrev) {
      for (var _i = 0; _i < this.prevItems.length; _i++) {
        this.prevItems[_i].addEventListener('click', this._prev);
      }
    }

    this._slider.addEventListener('keydown', this._handleKeydown);
  }

  _createClass(Controls, [{
    key: "_handleKeydown",
    value: function _handleKeydown(e) {
      // console.log('keydown');
      if (e.keyCode === 37) {
        // console.log('left');
        this._prev();
      }

      if (e.keyCode === 39) {
        // console.log('right');
        this._next();
      }
    }
  }, {
    key: "update",
    value: function update(showNext, showPrev) {
      if (this.initialisedNext) {
        if (showNext) this._enable(this.nextItems);else this._disable(this.nextItems);
      }

      if (this.initialisedPrev) {
        if (showPrev) this._enable(this.prevItems);else this._disable(this.prevItems);
      }
    }
  }, {
    key: "_disable",
    value: function _disable(els) {
      for (var i = 0; i < els.length; i++) {
        els[i].classList.add(CLASS_CONTROL_DISABLED);
      }
    }
  }, {
    key: "_enable",
    value: function _enable(els) {
      for (var i = 0; i < els.length; i++) {
        els[i].classList.remove(CLASS_CONTROL_DISABLED);
      }
    }
  }]);

  return Controls;
}();



/***/ }),

/***/ "./public/assets/scripts/components/opSlider/_dots.js":
/*!************************************************************!*\
  !*** ./public/assets/scripts/components/opSlider/_dots.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dots; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_DOT_ACTIVE = 'is-active';

var Dots =
/*#__PURE__*/
function () {
  function Dots(config) {
    var _this = this;

    _classCallCheck(this, Dots);

    _defineProperty(this, "initialised", false);

    if (typeof config.el === 'undefined') return;
    this.initialised = true;
    this.el = config.el;
    this.length = config.length;
    this.select = this.select.bind(this);
    this.items = [];

    var _loop = function _loop(i) {
      _this.items[i] = document.createElement('li');

      _this.items[i].addEventListener('click', function () {
        return config.onClick(i);
      });

      _this.el.appendChild(_this.items[i]);
    };

    for (var i = 0; i < this.length; i++) {
      _loop(i);
    }
  }

  _createClass(Dots, [{
    key: "select",
    value: function select(index) {
      if (!this.initialised) return;

      for (var i = 0; i < this.length; i++) {
        this.items[i].classList.remove(CLASS_DOT_ACTIVE);
      }

      this.items[index].classList.add(CLASS_DOT_ACTIVE);
    }
  }]);

  return Dots;
}();



/***/ }),

/***/ "./public/assets/scripts/components/opSlider/_events.js":
/*!**************************************************************!*\
  !*** ./public/assets/scripts/components/opSlider/_events.js ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Events; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! ./_helpers */ "./public/assets/scripts/components/opSlider/_helpers.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var Events =
/*#__PURE__*/
function () {
  function Events(config) {
    _classCallCheck(this, Events);

    _defineProperty(this, "_onDown", function () {});

    _defineProperty(this, "_onMove", function () {});

    _defineProperty(this, "_onUp", function () {});

    _defineProperty(this, "mouse", {
      down: false,
      moved: false,
      type: '',
      xStart: 0,
      yStart: 0,
      xDist: 0,
      yDist: 0,
      tap: false
    });

    this._frame = config.frame;
    this._list = config.list;
    this._onDown = config.onDown;
    this._onMove = config.onMove;
    this._onUp = config.onUp;
    this._onResize = config.onResize;
    this._handleLinkClick = this._handleLinkClick.bind(this);
    this._handleDown = this._handleDown.bind(this);
    this._handleMove = this._handleMove.bind(this);
    this._handleUp = this._handleUp.bind(this);

    if ('ontouchstart' in document.documentElement) {
      this._frame.addEventListener('touchstart', this._handleDown);

      this._frame.addEventListener('touchmove', this._handleMove);

      window.addEventListener('touchend', this._handleUp);
    } else {
      this._frame.addEventListener('mousedown', this._handleDown);

      this._frame.addEventListener('mousemove', this._handleMove);

      window.addEventListener('mouseup', this._handleUp);
    }

    this._list.addEventListener('click', this._handleLinkClick);
  }

  _createClass(Events, [{
    key: "_handleLinkClick",
    value: function _handleLinkClick(e) {
      if (!this.mouse.tap) {
        e.preventDefault();
      }
    }
  }, {
    key: "_handleDown",
    value: function _handleDown(e) {
      var m = this.mouse,
          _onD = this._onDown;
      if (m.down) return;
      m.type = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* getType */])(e);
      m.down = true;
      m.moved = false;
      m.tap = false;
      m.xStart = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* getX */])(e);
      m.yStart = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["c" /* getY */])(e);

      _onD();
    }
  }, {
    key: "_handleMove",
    value: function _handleMove(e) {
      var m = this.mouse,
          _onM = this._onMove;
      if (Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* getType */])(e) !== m.type) return;
      m.xDist = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* getX */])(e) - m.xStart; //* this.mult;

      m.yDist = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["c" /* getY */])(e) - m.yStart;

      if (!m.moved && Math.abs(m.yDist) > Math.abs(m.xDist)) {
        // If moved Y more than X (i.e scrolling)
        m.down = false;
      }

      if (m.down) e.preventDefault();
      if (!m.down) return;
      m.moved = true;

      _onM();
    }
  }, {
    key: "_handleUp",
    value: function _handleUp(e) {
      var m = this.mouse,
          _onU = this._onUp;
      if (!m.down) return;
      if (Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* getType */])(e) !== m.type) return;
      m.down = false;
      m.xDist = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* getX */])(e) - m.xStart;

      if (Math.abs(m.xDist) < 5) {
        // Tap
        m.tap = true;
        return;
      } else e.preventDefault();

      _onU();
    }
  }]);

  return Events;
}();



/***/ }),

/***/ "./public/assets/scripts/components/opSlider/_helpers.js":
/*!***************************************************************!*\
  !*** ./public/assets/scripts/components/opSlider/_helpers.js ***!
  \***************************************************************/
/*! exports provided: getX, getY, getType */
/*! exports used: getType, getX, getY */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getX;
/* harmony export (immutable) */ __webpack_exports__["c"] = getY;
/* harmony export (immutable) */ __webpack_exports__["a"] = getType;
function getX(e) {
  if (e.changedTouches) return e.changedTouches[0].clientX;else return e.clientX;
}
function getY(e) {
  if (e.changedTouches) return e.changedTouches[0].clientY;else return e.clientY;
}
function getType(e) {
  var type;

  switch (e.type) {
    case 'mousedown':
    case 'mouseup':
    case 'mousemove':
      type = 'mouse';
      break;

    case 'touchstart':
    case 'touchend':
    case 'touchmove':
      type = 'touch';
      break;

    case 'pointerdown':
    case 'pointerup':
    case 'pointermove':
      type = 'pointer';
      break;
  }

  return type;
}

/***/ }),

/***/ "./public/assets/scripts/components/opSlider/_slides.js":
/*!**************************************************************!*\
  !*** ./public/assets/scripts/components/opSlider/_slides.js ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slides; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CLASS_SLIDE_ACTIVE = 'is-slide-active';
var CLASS_SLIDE_CLONE = 'is-cloned';

var Slides =
/*#__PURE__*/
function () {
  function Slides(config) {
    _classCallCheck(this, Slides);

    _defineProperty(this, "initialised", false);

    _defineProperty(this, "widthSum", 0);

    _defineProperty(this, "clones", {
      left: {
        width: 0,
        length: 0,
        lengthOld: 0,
        arr: []
      },
      right: {
        width: 0,
        length: 0,
        lengthOld: 0,
        arr: []
      }
    });

    if (typeof config.els === 'undefined') return;
    this.initialised = true;
    this.parent = config.parent;
    this.els = config.els;
    this.mode = config.mode;
    this.length = config.els.length;
    this.rects = Array(this.length).fill(null);
    this.select = this.select.bind(this);
    this.tick = this.tick.bind(this);
    this.onFocus = this.onFocus.bind(this);

    for (var i = 0; i < this.length; i++) {
      this.els[i].setAttribute('index', i);
      this.els[i].setAttribute('tabindex', '-1');
      this.els[i].addEventListener('focus', this.onFocus);
    }
  }

  _createClass(Slides, [{
    key: "onFocus",
    value: function onFocus() {// console.log('item focused');
    }
  }, {
    key: "select",
    value: function select(index) {
      if (!this.initialised) return;

      for (var i = 0; i < this.length; i++) {
        this.els[i].classList.remove(CLASS_SLIDE_ACTIVE);
      }

      this.els[index].classList.add(CLASS_SLIDE_ACTIVE);
    }
  }, {
    key: "tick",
    value: function tick(frameWidth) {
      this.widthSum = 0;

      for (var i = 0; i < this.length; i++) {
        this.rects[i] = this.els[i].getBoundingClientRect();
        this.widthSum += this.rects[i].width;
      }

      if (this.mode.infinite) {
        this._updateClones(this.clones.left, true, frameWidth);

        this._updateClones(this.clones.right, false, frameWidth);
      }
    }
  }, {
    key: "closestSlide",
    value: function closestSlide(xDist, indexFrom, reverse) {
      var widthSlides = 0,
          width = Math.abs(xDist),
          index = indexFrom,
          length = 0,
          indexNew = indexFrom;

      while (width > widthSlides) {
        var prev = this.rects[index - 1] ? this.rects[index - 1].width * 1 / 3 : 0;
        widthSlides += this.rects[index].width * 2 / 3 + prev;
        length += 1;

        if (reverse) {
          index--;
          indexNew--;
          index = index < 0 ? this.length - 1 : index;
        } else {
          index++;
          indexNew++;
          index = index > this.length - 1 ? 0 : index;
        }
      } // console.log(index, indexFrom, length, indexNew);


      return indexNew;
    }
  }, {
    key: "_updateClones",
    value: function _updateClones(side, reverse, frameWidth) {
      var index = reverse ? this.length - 1 : 0;
      var widthVisible = frameWidth;
      side.lengthOld = side.length;
      side.width = 0;
      side.length = 0;
      if (this.mode.centered) widthVisible += frameWidth / 2; // Find out how many slides needed to fill widthVisible

      while (widthVisible > side.width) {
        side.width += this.rects[index].width;

        if (typeof side.arr[side.length] === 'undefined') {
          side.arr[side.length] = this._createClone(this.els[index]);
        }

        side.length += 1;

        if (reverse) {
          index--;
          index = index < 0 ? this.length - 1 : index;
        } else {
          index++;
          index = index > this.length - 1 ? 0 : index;
        }
      }

      this._refreshClones(side, reverse);
    }
  }, {
    key: "_createClone",
    value: function _createClone(el) {
      // console.log('create clone', );
      var clone = el.cloneNode(true);
      clone.classList.add(CLASS_SLIDE_CLONE);
      return {
        node: clone,
        inTheDom: false
      };
    } // Refreshing the DOM

  }, {
    key: "_refreshClones",
    value: function _refreshClones(side, reverse) {
      for (var i = 0; i < side.arr.length; i++) {
        if (i >= side.length) {
          if (side.arr[i].inTheDom) {
            side.arr[i].inTheDom = false;
            this.parent.removeChild(side.arr[i].node);
          }
        } else {
          if (!side.arr[i].inTheDom) {
            side.arr[i].inTheDom = true;
            if (reverse) this.parent.insertBefore(side.arr[i].node, this.parent.firstChild);else this.parent.appendChild(side.arr[i].node);
          }
        }
      }
    }
  }]);

  return Slides;
}();



/***/ }),

/***/ "./public/assets/scripts/components/opSlider/opSlider.js":
/*!***************************************************************!*\
  !*** ./public/assets/scripts/components/opSlider/opSlider.js ***!
  \***************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_rect__ = __webpack_require__(/*! ./../../helpers/rect */ "./public/assets/scripts/helpers/rect.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_AF__ = __webpack_require__(/*! ./../../helpers/AF */ "./public/assets/scripts/helpers/AF.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events__ = __webpack_require__(/*! ./_events */ "./public/assets/scripts/components/opSlider/_events.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dots__ = __webpack_require__(/*! ./_dots */ "./public/assets/scripts/components/opSlider/_dots.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controls__ = __webpack_require__(/*! ./_controls */ "./public/assets/scripts/components/opSlider/_controls.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__animation__ = __webpack_require__(/*! ./_animation */ "./public/assets/scripts/components/opSlider/_animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__slides__ = __webpack_require__(/*! ./_slides */ "./public/assets/scripts/components/opSlider/_slides.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__autoplay__ = __webpack_require__(/*! ./_autoplay */ "./public/assets/scripts/components/opSlider/_autoplay.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
    v1.5
    - Added disabled drag animation option (dragAllowed)
    - Added diable js animation (animationAllowed)

    v1.4
    - Added select callback (call whatever function on new select (has index of the element as a parameter)
    - Added disable if frame is bigger than all slides
    
    v1.3
    Quick swipe:
        - if swiped small amount within 1 sec and released, go to next slide.
        - Swiping longer then 1 sec, only go next after dragged certain amount of px


    mode.fill: 
        overwritten by mode.centered
        overwritten by mode.infinite
    
    v.1.3
    Fixes:
    - Fix - this.indexMax wrong calculation if only one item in the frame
*/









var OpSlider =
/*#__PURE__*/
function () {
  function OpSlider(config) {
    _classCallCheck(this, OpSlider);

    _defineProperty(this, "index", 0);

    _defineProperty(this, "x", 0);

    _defineProperty(this, "xMin", 0);

    _defineProperty(this, "xMax", 0);

    _defineProperty(this, "indexMax", null);

    _defineProperty(this, "disabled", false);

    _defineProperty(this, "dragAllowed", void 0);

    _defineProperty(this, "animationAllowed", void 0);

    this.slider = config.slider;
    this.list = config.list;
    this.frame = config.frame;
    this.rect = this.frame.getBoundingClientRect();
    this.length = config.slides.length;
    this.indexMax = this.length - 1;
    this.onSelectCallback = config.onSelect || null;
    this.dragAllowed = typeof config.dragAllowed === 'undefined' ? true : config.dragAllowed;
    this.animationAllowed = typeof config.animationAllowed === 'undefined' ? true : config.animationAllowed;
    this.mode = {
      centered: config.mode.centered || false,
      infinite: config.mode.infinite || false,
      multiple: config.mode.multiple || false,
      updateDotsOnDrag: config.mode.updateDotsOnDrag || false,
      fill: config.mode.centered || config.mode.infinite ? false : config.mode.fill || false,
      loop: config.mode.loop || false
    };
    this.af = __WEBPACK_IMPORTED_MODULE_1__helpers_AF__["a" /* default */].instance();
    this.onResize = this.onResize.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onDown = this.onDown.bind(this);
    this.onMove = this.onMove.bind(this);
    this.onUp = this.onUp.bind(this);
    this.tick = this.tick.bind(this);
    this.prev = this.prev.bind(this);
    this.next = this.next.bind(this);
    this.select = this.select.bind(this);

    if (this.dragAllowed) {
      this.events = new __WEBPACK_IMPORTED_MODULE_2__events__["a" /* default */]({
        frame: this.slider,
        list: this.list,
        onDown: this.onDown,
        onMove: this.onMove,
        onUp: this.onUp
      });
    }

    this.dots = new __WEBPACK_IMPORTED_MODULE_3__dots__["a" /* default */]({
      el: config.dots,
      length: this.length,
      onClick: this.select
    });
    this.controls = new __WEBPACK_IMPORTED_MODULE_4__controls__["a" /* default */]({
      slider: this.slider,
      nextItems: config.nextItems,
      prevItems: config.prevItems,
      next: this.next,
      prev: this.prev
    });
    this.slides = new __WEBPACK_IMPORTED_MODULE_6__slides__["a" /* default */]({
      parent: this.list,
      els: config.slides,
      mode: this.mode
    });
    this.autoplay = new __WEBPACK_IMPORTED_MODULE_7__autoplay__["a" /* default */]({
      callback: this.next,
      settings: config.autoplay
    });
    this.autoplay.start();

    if (this.animationAllowed) {
      this.animation = new __WEBPACK_IMPORTED_MODULE_5__animation__["a" /* default */](this.list);
    }

    this.onResize();
    window.addEventListener('resize', this.onResize); // this.slider.setAttribute('tabindex', 0);

    this.slider.addEventListener('focus', this.onFocus);
    this.slider.addEventListener('blur', this.onBlur);
    this.af.onNextRead(this.tick);
    this.select(this.index, true);
  }

  _createClass(OpSlider, [{
    key: "onFocus",
    value: function onFocus() {
      console.log('focused');
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      console.log('Blured');
    }
  }, {
    key: "onResize",
    value: function onResize() {
      var scope = this;
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(function () {
        scope.af.onNextRead(scope.tick);
        scope.select(scope.index);
      }, 250);
    }
  }, {
    key: "tick",
    value: function tick() {
      this.rect = this.frame.getBoundingClientRect();
      this.slides.tick(this.rect.width); // If frame is bigger than it's contents, disable slider
      // No point dragging as it's already all visible

      if (this.rect.width > this.slides.widthSum) this.disabled = true;else this.disabled = false;
      this.xMin = this._calcX(this.length - 1);
      this.xMax = this._calcX(0);
    }
  }, {
    key: "_calcX",
    value: function _calcX(index) {
      var s = this.slides,
          r = this.rect;
      var x = 0,
          xFillFrame = r.width - s.widthSum;

      if (this.mode.centered) {
        x = r.width / 2 - s.rects[index].width / 2;
      }

      if (this.mode.infinite) {
        x -= this.slides.clones.left.width;
      }

      for (var i = 0; i < index; i++) {
        x -= s.rects[i].width;

        if (this.mode.fill && x < xFillFrame) {
          x = xFillFrame;
          this.indexMax = i + 1;
          break;
        }
      }

      return x;
    }
  }, {
    key: "onDown",
    value: function onDown() {
      if (this.disabled) return;
      this.autoplay.stop();
    }
  }, {
    key: "onMove",
    value: function onMove() {
      if (this.disabled) return;
      var e = this.events,
          l = this.length;

      var x = e.mouse.xDist + this._calcX(this.index);

      this.x = this._resist(x);

      if (this.animationAllowed) {
        this.animation.drag(this.x);
      }

      if (this.mode.updateDotsOnDrag) {
        var index = this.slides.closestSlide(e.mouse.xDist, this.index, e.mouse.xDist > 0);
        var max = this.mode.fill ? this.indexMax : l - 1;
        var min = 0;

        if (index < min) {
          index = this.mode.infinite ? l + index : min;
        } else if (index > max) {
          index = this.mode.infinite ? index - l : max;
        }

        this.dots.select(index);
      }
    }
  }, {
    key: "_resist",
    value: function _resist(x) {
      if (this.mode.infinite) return x;

      if (x > this.xMax) {
        return this.xMax + Math.sqrt(Math.abs(x - this.xMax)) * 4;
      } else if (x < this.xMin) {
        return this.xMin - Math.sqrt(Math.abs(x - this.xMin)) * 4;
      } else {
        return x;
      }
    }
  }, {
    key: "onUp",
    value: function onUp() {
      if (this.disabled) return;

      if (this.events.mouse.xDist > 50) {
        this.prev(true);
      } else if (this.events.mouse.xDist < -50) {
        this.next(true);
      } else {
        this.select(this.index);
      }
    }
  }, {
    key: "prev",
    value: function prev() {
      var dragged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var index = this.index - 1;

      if (this.mode.multiple & dragged) {
        index = this.slides.closestSlide(this.events.mouse.xDist, this.index, true);
      }

      if ((this.mode.infinite || this.mode.loop) && this.animationAllowed) {
        if (index < 0) {
          index = this.length - Math.abs(index % this.length);
          if (this.mode.infinite) this.animation.offset(this.slides.widthSum);
        }
      } else index = Math.max(index, 0);

      this.select(index);
    }
  }, {
    key: "next",
    value: function next() {
      var dragged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var index = this.index + 1;

      if (this.mode.multiple & dragged) {
        index = this.slides.closestSlide(this.events.mouse.xDist, this.index, false);
      }

      if ((this.mode.infinite || this.mode.loop) && this.animationAllowed) {
        if (index > this.length - 1) {
          index = index % this.length;
          if (this.mode.infinite) this.animation.offset(-this.slides.widthSum);
        }
      } else index = Math.min(index, this.length - 1);

      this.select(index);
    }
  }, {
    key: "select",
    value: function select(index) {
      var _this = this;

      var instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.af.onNextWrite(function () {
        _this.index = index;

        if (_this.mode.fill) {
          _this.index = Math.min(index, _this.indexMax);
        }

        _this.x = _this._calcX(_this.index);

        _this.dots.select(_this.index);

        _this.slides.select(_this.index);

        if (!_this.mode.infinite) {
          var max = _this.mode.fill ? _this.indexMax : _this.length - 1;
          var min = 0;
          var showNext = _this.index < max,
              showPrev = _this.index > min;

          _this.controls.update(showNext, showPrev);
        }

        if (!_this.disabled) {
          if (_this.animationAllowed) {
            if (instant) _this.animation.jump(_this.x);else _this.animation.release(_this.x);
          } else {
            _this.list.style.transform = 'translate3d(' + _this.x + 'px, 0, 0)';
          }
        }

        _this.autoplay.restart();

        if (_this.onSelectCallback) _this.onSelectCallback(index);
      });
    }
  }]);

  return OpSlider;
}();



/***/ }),

/***/ "./public/assets/scripts/components/products/AlgoliaCredit.js":
/*!********************************************************************!*\
  !*** ./public/assets/scripts/components/products/AlgoliaCredit.js ***!
  \********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlgoliaCredit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var AlgoliaCredit =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(AlgoliaCredit, _PureComponent);

  function AlgoliaCredit() {
    _classCallCheck(this, AlgoliaCredit);

    return _possibleConstructorReturn(this, _getPrototypeOf(AlgoliaCredit).apply(this, arguments));
  }

  _createClass(AlgoliaCredit, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: __webpack_require__(/*! ~/images/logos/search-by-algolia-light-background-8762ce8b.svg */ "./public/assets/images/logos/search-by-algolia-light-background-8762ce8b.svg"),
        className: "algolia-credit"
      });
    }
  }]);

  return AlgoliaCredit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);



/***/ }),

/***/ "./public/assets/scripts/components/products/Applications.js":
/*!*******************************************************************!*\
  !*** ./public/assets/scripts/components/products/Applications.js ***!
  \*******************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_components_products_FilterSubSection__ = __webpack_require__(/*! ~/scripts/components/products/FilterSubSection */ "./public/assets/scripts/components/products/FilterSubSection.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var ProductCategory =
/*#__PURE__*/
function (_Component) {
  _inherits(ProductCategory, _Component);

  function ProductCategory() {
    _classCallCheck(this, ProductCategory);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductCategory).apply(this, arguments));
  }

  _createClass(ProductCategory, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__scripts_components_products_FilterSubSection__["a" /* default */], {
        heading: "Application"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["d" /* RefinementList */], {
        className: "refinement-list",
        attribute: "family.applications",
        transformItems: function transformItems(items) {
          return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"])(items, ["label", "count"], ["asc", "desc"]);
        },
        limit: 100
      }));
    }
  }]);

  return ProductCategory;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ProductCategory);

/***/ }),

/***/ "./public/assets/scripts/components/products/Brands.js":
/*!*************************************************************!*\
  !*** ./public/assets/scripts/components/products/Brands.js ***!
  \*************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_components_products_FilterSubSection__ = __webpack_require__(/*! ~/scripts/components/products/FilterSubSection */ "./public/assets/scripts/components/products/FilterSubSection.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var Brand =
/*#__PURE__*/
function (_Component) {
  _inherits(Brand, _Component);

  function Brand() {
    _classCallCheck(this, Brand);

    return _possibleConstructorReturn(this, _getPrototypeOf(Brand).apply(this, arguments));
  }

  _createClass(Brand, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__scripts_components_products_FilterSubSection__["a" /* default */], {
        heading: "Brand"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["d" /* RefinementList */], {
        className: "refinement-list",
        attribute: "family.brand",
        transformItems: function transformItems(items) {
          return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"])(items, ["label", "count"], ["asc", "desc"]);
        },
        limit: 100
      }));
    }
  }]);

  return Brand;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Brand);

/***/ }),

/***/ "./public/assets/scripts/components/products/Clear.js":
/*!************************************************************!*\
  !*** ./public/assets/scripts/components/products/Clear.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Clear =
/*#__PURE__*/
function (_Component) {
  _inherits(Clear, _Component);

  function Clear() {
    _classCallCheck(this, Clear);

    return _possibleConstructorReturn(this, _getPrototypeOf(Clear).apply(this, arguments));
  }

  _createClass(Clear, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          linkText = _this$props.linkText,
          items = _this$props.items,
          query = _this$props.searchState.query;
      return items.length || query ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["a" /* ClearRefinements */], {
        clearsQuery: true,
        translations: {
          reset: linkText
        }
      }) : null;
    }
  }]);

  return Clear;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Clear, "propTypes", {
  linkText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  searchState: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["f" /* connectCurrentRefinements */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["j" /* connectStateResults */])(Clear)));

/***/ }),

/***/ "./public/assets/scripts/components/products/Container.js":
/*!****************************************************************!*\
  !*** ./public/assets/scripts/components/products/Container.js ***!
  \****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var ProductSearchContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(ProductSearchContainer, _Component);

  function ProductSearchContainer() {
    _classCallCheck(this, ProductSearchContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSearchContainer).apply(this, arguments));
  }

  _createClass(ProductSearchContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["children"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
        className: "container-fluid"
      }, rest), children);
    }
  }]);

  return ProductSearchContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ProductSearchContainer);

/***/ }),

/***/ "./public/assets/scripts/components/products/CurrentRefinements.js":
/*!*************************************************************************!*\
  !*** ./public/assets/scripts/components/products/CurrentRefinements.js ***!
  \*************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(/*! classnames */ "./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var itemPropTypes = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  items: function items() {
    return itemPropTypes.apply(void 0, arguments);
  }
}));
var cx = Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["l" /* createClassNames */])("CurrentRefinements");

var CurrentRefinements =
/*#__PURE__*/
function (_Component) {
  _inherits(CurrentRefinements, _Component);

  function CurrentRefinements() {
    _classCallCheck(this, CurrentRefinements);

    return _possibleConstructorReturn(this, _getPrototypeOf(CurrentRefinements).apply(this, arguments));
  }

  _createClass(CurrentRefinements, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          canRefine = _this$props.canRefine,
          refine = _this$props.refine;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(cx("", !canRefine && "-noRefinement"))
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: cx("list", !canRefine && "list--noRefinement")
      }, items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          key: item.id,
          className: cx("item")
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: cx("label")
        }, item.label.replace("".concat(item.attribute, ": "), "")), item.items ? item.items.map(function (nest) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            key: nest.label,
            className: cx("category")
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            className: cx("categoryLabel")
          }, nest.label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
            className: cx("delete"),
            onClick: function onClick() {
              return refine(nest.value);
            }
          }, "x"));
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: cx("category")
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          className: cx("delete"),
          onClick: function onClick() {
            return refine(item.value);
          }
        }, "x")));
      })));
    }
  }]);

  return CurrentRefinements;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(CurrentRefinements, "propTypes", {
  items: itemPropTypes.isRequired,
  canRefine: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  refine: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["f" /* connectCurrentRefinements */])(CurrentRefinements));

/***/ }),

/***/ "./public/assets/scripts/components/products/FilterSubSection.js":
/*!***********************************************************************!*\
  !*** ./public/assets/scripts/components/products/FilterSubSection.js ***!
  \***********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var FilterSubSection =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterSubSection, _Component);

  function FilterSubSection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FilterSubSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FilterSubSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
      _this.setState({
        active: !_this.state.active
      });
    });

    return _this;
  }

  _createClass(FilterSubSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          heading = _this$props.heading;
      var active = this.state.active;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filter-sub-section ".concat(active ? "is-accordion-active" : "")
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filter-sub-section__heading",
        onClick: this.handleClick
      }, heading, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filter-sub-section__icon"
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filter-sub-section__collapse"
      }, children));
    }
  }]);

  return FilterSubSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(FilterSubSection, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (FilterSubSection);

/***/ }),

/***/ "./public/assets/scripts/components/products/Filters.js":
/*!**************************************************************!*\
  !*** ./public/assets/scripts/components/products/Filters.js ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_components_products_ProductCategory__ = __webpack_require__(/*! ~/scripts/components/products/ProductCategory */ "./public/assets/scripts/components/products/ProductCategory.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_components_products_Applications__ = __webpack_require__(/*! ~/scripts/components/products/Applications */ "./public/assets/scripts/components/products/Applications.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_components_products_LumenOutput__ = __webpack_require__(/*! ~/scripts/components/products/LumenOutput */ "./public/assets/scripts/components/products/LumenOutput.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_components_products_Brands__ = __webpack_require__(/*! ~/scripts/components/products/Brands */ "./public/assets/scripts/components/products/Brands.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scripts_components_products_IPRating__ = __webpack_require__(/*! ~/scripts/components/products/IPRating */ "./public/assets/scripts/components/products/IPRating.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scripts_components_products_AlgoliaCredit__ = __webpack_require__(/*! ~/scripts/components/products/AlgoliaCredit */ "./public/assets/scripts/components/products/AlgoliaCredit.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var Filters =
/*#__PURE__*/
function (_Component) {
  _inherits(Filters, _Component);

  function Filters() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Filters);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Filters)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
      _this.setState({
        active: !_this.state.active
      });
    });

    return _this;
  }

  _createClass(Filters, [{
    key: "render",
    value: function render() {
      var nbHits = this.props.nbHits;
      var active = this.state.active;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filters ".concat(active ? "is-filters-active" : "")
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "filters__title",
        onClick: this.handleClick
      }, "Filter products ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "(", nbHits, ")")), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filters__body"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filters__section"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filters__section-title"
      }, "Categories"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__scripts_components_products_ProductCategory__["a" /* default */], null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filters__section"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filters__section-title"
      }, "Filters"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__scripts_components_products_Applications__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__scripts_components_products_LumenOutput__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__scripts_components_products_Brands__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__scripts_components_products_IPRating__["a" /* default */], null)), window.__ENV_DATA__.ENV !== "production" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "filters__section"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__scripts_components_products_AlgoliaCredit__["a" /* default */], null))));
    }
  }]);

  return Filters;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Filters, "propTypes", {
  nbHits: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__["k" /* connectStats */])(Filters));

/***/ }),

/***/ "./public/assets/scripts/components/products/Hits.js":
/*!***********************************************************!*\
  !*** ./public/assets/scripts/components/products/Hits.js ***!
  \***********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(/*! classnames */ "./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Hits =
/*#__PURE__*/
function (_Component) {
  _inherits(Hits, _Component);

  function Hits(props) {
    var _this;

    _classCallCheck(this, Hits);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Hits).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      hovered: false,
      bannerActive: true
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseOver", function () {
      _this.setState({
        hovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseOut", function () {
      _this.setState({
        hovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRef", function (ref) {
      _this.ref = ref;
    });

    _this.handleScroll = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["throttle"])(_this.handleScroll.bind(_assertThisInitialized(_assertThisInitialized(_this))), 250);
    return _this;
  }

  _createClass(Hits, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var _this$props = this.props,
          hasMore = _this$props.hasMore,
          refine = _this$props.refine;

      if (!hasMore) {
        return;
      }

      var _this$ref$getBounding = this.ref.getBoundingClientRect(),
          bottom = _this$ref$getBounding.bottom;

      var _window = window,
          innerHeight = _window.innerHeight; // When the bottom of the grid is half a window height away from
      // appearing in the viewport

      if (bottom - innerHeight / 2 <= innerHeight) {
        refine();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          hits = _this$props2.hits,
          HitComponent = _this$props2.hitComponent,
          brand = _this$props2.brand,
          listType = _this$props2.listType;
      var hovered = this.state.hovered;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()("hits", {
          "hits--hovered": hovered,
          "hits--no-banner": !brand
        }),
        ref: this.handleRef
      }, brand && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "hits__banner"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "hits__banner-logo",
        style: {
          backgroundImage: "url('".concat(brand.image, "')")
        }
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "hits__banner-text",
        dangerouslySetInnerHTML: {
          __html: brand.description
        }
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "hits__wrap"
      }, hits.map(function (hit, index) {
        return hit.family && hit.family.brand ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          key: hit.objectID,
          className: "hits__hit",
          onMouseOver: _this2.handleMouseOver,
          onMouseOut: _this2.handleMouseOut
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "hits__hit-inside"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HitComponent, {
          hit: hit,
          position: index,
          listType: listType
        }))) : null;
      })));
    }
  }]);

  return Hits;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Hits, "propTypes", {
  hitComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  brand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  listType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  hits: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,
  hasMore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  refine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__["g" /* connectInfiniteHits */])(Hits));

/***/ }),

/***/ "./public/assets/scripts/components/products/IPRating.js":
/*!***************************************************************!*\
  !*** ./public/assets/scripts/components/products/IPRating.js ***!
  \***************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_components_products_FilterSubSection__ = __webpack_require__(/*! ~/scripts/components/products/FilterSubSection */ "./public/assets/scripts/components/products/FilterSubSection.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var IPRating =
/*#__PURE__*/
function (_Component) {
  _inherits(IPRating, _Component);

  function IPRating() {
    _classCallCheck(this, IPRating);

    return _possibleConstructorReturn(this, _getPrototypeOf(IPRating).apply(this, arguments));
  }

  _createClass(IPRating, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__scripts_components_products_FilterSubSection__["a" /* default */], {
        heading: "IP Rating"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["d" /* RefinementList */], {
        className: "refinement-list",
        attribute: "family.ipRating",
        transformItems: function transformItems(items) {
          return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"])(items, ["label", "count"], ["asc", "desc"]);
        },
        limit: 100
      }));
    }
  }]);

  return IPRating;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (IPRating);

/***/ }),

/***/ "./public/assets/scripts/components/products/LumenOutput.js":
/*!******************************************************************!*\
  !*** ./public/assets/scripts/components/products/LumenOutput.js ***!
  \******************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_components_products_FilterSubSection__ = __webpack_require__(/*! ~/scripts/components/products/FilterSubSection */ "./public/assets/scripts/components/products/FilterSubSection.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_components_products_Range__ = __webpack_require__(/*! ~/scripts/components/products/Range */ "./public/assets/scripts/components/products/Range.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var LumenOutput =
/*#__PURE__*/
function (_Component) {
  _inherits(LumenOutput, _Component);

  function LumenOutput() {
    _classCallCheck(this, LumenOutput);

    return _possibleConstructorReturn(this, _getPrototypeOf(LumenOutput).apply(this, arguments));
  }

  _createClass(LumenOutput, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__scripts_components_products_FilterSubSection__["a" /* default */], {
        heading: "Lumen Output"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__scripts_components_products_Range__["a" /* default */], {
        attribute: "lumens",
        sliderMin: 0,
        sliderMax: 25000
      }));
    }
  }]);

  return LumenOutput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LumenOutput);

/***/ }),

/***/ "./public/assets/scripts/components/products/NoResults.js":
/*!****************************************************************!*\
  !*** ./public/assets/scripts/components/products/NoResults.js ***!
  \****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_components_products_Reset__ = __webpack_require__(/*! ~/scripts/components/products/Reset */ "./public/assets/scripts/components/products/Reset.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var NoResults =
/*#__PURE__*/
function (_Component) {
  _inherits(NoResults, _Component);

  function NoResults() {
    _classCallCheck(this, NoResults);

    return _possibleConstructorReturn(this, _getPrototypeOf(NoResults).apply(this, arguments));
  }

  _createClass(NoResults, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "no-results"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "no-results__message"
      }, "Sorry, there are no results that match your query."), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "no-results__link"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__scripts_components_products_Reset__["a" /* default */], {
        linkText: "Click here to start again.",
        clearsQuery: true
      })));
    }
  }]);

  return NoResults;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NoResults);

/***/ }),

/***/ "./public/assets/scripts/components/products/ProductCard.js":
/*!******************************************************************!*\
  !*** ./public/assets/scripts/components/products/ProductCard.js ***!
  \******************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var ProductCard =
/*#__PURE__*/
function (_Component) {
  _inherits(ProductCard, _Component);

  function ProductCard(props) {
    var _this;

    _classCallCheck(this, ProductCard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductCard).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleIntersection", function (entries) {
      entries.map(function (entry) {
        if (entry.isIntersecting) {
          var _this$props = _this.props,
              _this$props$hit$famil = _this$props.hit.family,
              title = _this$props$hit$famil.title,
              brand = _this$props$hit$famil.brand,
              categories = _this$props$hit$famil.categories,
              position = _this$props.position,
              listType = _this$props.listType;
          var category = categories.lvl1 ? categories.lvl1.join("|") : "";

          _this.trackImpression(title, category, brand, listType, position);

          _this.hitsObserver.unobserve(entry.target);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "trackImpression", function (name, category, brand, list, position) {
      var _window = window,
          ga = _window.ga;

      if (!ga) {
        console.warn("Google Analytics is not loaded - Can't track product card impression");
        return;
      } // Requiring Enhanced Ecommerce plugin stops queue execution so we know
      // that the other commands after will execute when the tracker is ready


      ga("require", "ec", "ec.js");
      ga("ec:addImpression", {
        name: name,
        category: category,
        brand: brand,
        list: list,
        position: position // 'position' indicates the product position in the list.

      });
      ga("send", "pageview"); // Send product impressions with initial pageview.
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRef", function (ref) {
      if (_this.ref !== ref) {
        if (!_this.ref && ref) {
          _this.hitsObserver.observe(ref);
        }

        if (_this.ref && !ref) {
          _this.hitsObserver.unobserve(_this.ref);
        }
      }

      _this.ref = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
      var _this$props2 = _this.props,
          _this$props2$hit$fami = _this$props2.hit.family,
          title = _this$props2$hit$fami.title,
          brand = _this$props2$hit$fami.brand,
          categories = _this$props2$hit$fami.categories,
          url = _this$props2$hit$fami.url,
          position = _this$props2.position,
          listType = _this$props2.listType;
      var category = categories.lvl1 ? categories.lvl1.join("|") : "";
      var _window2 = window,
          ga = _window2.ga;

      if (!ga) {
        console.warn("Google Analytics is not loaded - Can't track product card click");
        return;
      }

      event.preventDefault();
      ga("ec:addProduct", {
        name: title,
        category: category,
        brand: brand,
        position: position
      });
      ga("ec:setAction", "click", {
        list: listType
      }); // Send click with an event, then send user to product page.

      ga("send", "event", "UX", "click", "Results", {
        hitCallback: function hitCallback() {
          document.location = url;
        }
      });
    });

    _this.hitsObserver = new IntersectionObserver(_this.handleIntersection, {
      threshold: 1
    });
    return _this;
  }

  _createClass(ProductCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      objectFitPolyfill();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.hit.family.image !== this.props.hit.family.image) {
        objectFitPolyfill();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.hitsObserver.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$hit$famil2 = this.props.hit.family,
          brand = _this$props$hit$famil2.brand,
          title = _this$props$hit$famil2.title,
          url = _this$props$hit$famil2.url,
          image = _this$props$hit$famil2.image;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: "product-card product-card--clean",
        href: url,
        ref: this.handleRef,
        onClick: this.handleClick
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "product-card__card"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "product-card__image-wrap"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "product-card__image"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: image,
        alt: title,
        "data-object-fit": "contain"
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "product-card__info"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "product-card__family"
      }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "product-card__brand"
      }, brand))));
    }
  }]);

  return ProductCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ProductCard, "propTypes", {
  hit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    family: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      brand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    })
  }),
  position: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  listType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (ProductCard);

/***/ }),

/***/ "./public/assets/scripts/components/products/ProductCategory.js":
/*!**********************************************************************!*\
  !*** ./public/assets/scripts/components/products/ProductCategory.js ***!
  \**********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_components_products_FilterSubSection__ = __webpack_require__(/*! ~/scripts/components/products/FilterSubSection */ "./public/assets/scripts/components/products/FilterSubSection.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var ProductCategory =
/*#__PURE__*/
function (_Component) {
  _inherits(ProductCategory, _Component);

  function ProductCategory() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ProductCategory);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ProductCategory)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "transformItems", function (items) {
      var count = 0;
      var isRefined = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.isRefined) {
            isRefined = false;
          }

          count += item.count;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      items.unshift({
        label: "All",
        value: "",
        count: count,
        isRefined: isRefined
      });
      return items;
    });

    return _this;
  }

  _createClass(ProductCategory, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__scripts_components_products_FilterSubSection__["a" /* default */], {
        heading: "Product Type"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["b" /* HierarchicalMenu */], {
        attributes: ["family.categories.lvl0", "family.categories.lvl1"],
        transformItems: this.transformItems,
        limit: 100
      }));
    }
  }]);

  return ProductCategory;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ProductCategory);

/***/ }),

/***/ "./public/assets/scripts/components/products/ProductsGrid.js":
/*!*******************************************************************!*\
  !*** ./public/assets/scripts/components/products/ProductsGrid.js ***!
  \*******************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(/*! classnames */ "./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_components_products_Hits__ = __webpack_require__(/*! ~/scripts/components/products/Hits */ "./public/assets/scripts/components/products/Hits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_components_products_CurrentRefinements__ = __webpack_require__(/*! ~/scripts/components/products/CurrentRefinements */ "./public/assets/scripts/components/products/CurrentRefinements.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_components_products_Clear__ = __webpack_require__(/*! ~/scripts/components/products/Clear */ "./public/assets/scripts/components/products/Clear.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scripts_components_products_Query__ = __webpack_require__(/*! ~/scripts/components/products/Query */ "./public/assets/scripts/components/products/Query.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scripts_components_products_NoResults__ = __webpack_require__(/*! ~/scripts/components/products/NoResults */ "./public/assets/scripts/components/products/NoResults.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scripts_components_products_Searching__ = __webpack_require__(/*! ~/scripts/components/products/Searching */ "./public/assets/scripts/components/products/Searching.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scripts_components_products_ProductCard__ = __webpack_require__(/*! ~/scripts/components/products/ProductCard */ "./public/assets/scripts/components/products/ProductCard.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var itemPropTypes = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  items: function items() {
    return itemPropTypes.apply(void 0, arguments);
  }
}));

var ProductsGrid =
/*#__PURE__*/
function (_Component) {
  _inherits(ProductsGrid, _Component);

  function ProductsGrid() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ProductsGrid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ProductsGrid)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "brandRefinement", function () {
      var items = _this.props.items;

      if (items.length !== 1) {
        return null;
      }

      var item = items[0];

      if (item.attribute === "family.brand" && item.currentRefinement.length === 1) {
        var brandTitle = item.currentRefinement[0];
        return window.brands.find(function (item) {
          return item.title === brandTitle;
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getListType", function (_ref) {
      var hierarchicalMenu = _ref.hierarchicalMenu,
          range = _ref.range,
          refinementList = _ref.refinementList,
          query = _ref.query;

      if (query) {
        return "Search";
      }

      var categoryFilterApplied = false;
      var otherFilterApplied = false;

      if (hierarchicalMenu) {
        if (hierarchicalMenu["family.categories.lvl0"].length > 0) {
          categoryFilterApplied = true;
        }
      }

      if (refinementList) {
        for (var attribute in refinementList) {
          if (refinementList[attribute].length > 0) {
            otherFilterApplied = true;
          }
        }
      }

      if (range && range.lumens) {
        var _range$lumens = range.lumens,
            min = _range$lumens.min,
            max = _range$lumens.max;

        if (min || max) {
          otherFilterApplied = true;
        }
      }

      if (categoryFilterApplied && otherFilterApplied) {
        return "Category + Filter";
      }

      if (categoryFilterApplied) {
        return "Category";
      }

      if (otherFilterApplied) {
        return "Filter";
      }

      return "Index";
    });

    return _this;
  }

  _createClass(ProductsGrid, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          searching = _this$props.searching,
          searchResults = _this$props.searchResults,
          searchState = _this$props.searchState,
          items = _this$props.items;
      var listType = this.getListType(searchState);

      var page = searchState.page,
          params = _objectWithoutProperties(searchState, ["page"]);

      var hash = JSON.stringify(params);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "products-grid"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("products-grid__refs", {
          "has-items": items.length || searchState.query
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "products-grid__ref-items"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__scripts_components_products_CurrentRefinements__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__scripts_components_products_Query__["a" /* default */], null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "products-grid__clear"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__scripts_components_products_Clear__["a" /* default */], {
        linkText: "Clear Filters"
      }))), searchResults && (searchResults.nbHits !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__scripts_components_products_Hits__["a" /* default */], {
        key: hash,
        hitComponent: __WEBPACK_IMPORTED_MODULE_10__scripts_components_products_ProductCard__["a" /* default */],
        brand: this.brandRefinement(),
        listType: listType
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__scripts_components_products_NoResults__["a" /* default */], null)), searching && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__scripts_components_products_Searching__["a" /* default */], {
        theme: "dark"
      }));
    }
  }]);

  return ProductsGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ProductsGrid, "propTypes", {
  searchState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  searching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  searchResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    nbHits: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  items: itemPropTypes
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__["f" /* connectCurrentRefinements */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__["j" /* connectStateResults */])(ProductsGrid)));

/***/ }),

/***/ "./public/assets/scripts/components/products/Query.js":
/*!************************************************************!*\
  !*** ./public/assets/scripts/components/products/Query.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var cx = Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["l" /* createClassNames */])("CurrentRefinements");

var Query =
/*#__PURE__*/
function (_Component) {
  _inherits(Query, _Component);

  function Query() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Query);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Query)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
      _this.props.refine();
    });

    return _this;
  }

  _createClass(Query, [{
    key: "render",
    value: function render() {
      var currentRefinement = this.props.currentRefinement;

      if (!currentRefinement) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: cx("")
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: cx("list")
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: cx("item")
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: cx("label")
      }, "\u2018", currentRefinement, "\u2019"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: cx("category")
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: cx("delete"),
        onClick: this.handleClick
      }, "x")))));
    }
  }]);

  return Query;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Query, "propTypes", {
  currentRefinement: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  refine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["i" /* connectSearchBox */])(Query));

/***/ }),

/***/ "./public/assets/scripts/components/products/Range.js":
/*!************************************************************!*\
  !*** ./public/assets/scripts/components/products/Range.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rheostat__ = __webpack_require__(/*! rheostat */ "./node_modules/rheostat/lib/Slider.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rheostat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rheostat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Range =
/*#__PURE__*/
function (_Component) {
  _inherits(Range, _Component);

  function Range(props) {
    var _this;

    _classCallCheck(this, Range);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Range).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (sliderState) {
      var _this$props = _this.props,
          currentRefinement = _this$props.currentRefinement,
          refine = _this$props.refine,
          min = _this$props.min,
          max = _this$props.max,
          sliderMin = _this$props.sliderMin,
          sliderMax = _this$props.sliderMax;

      var values = _this.extractValuesFromSliderState(sliderState);

      _this.setState({
        values: values
      });

      if (currentRefinement.min !== values.min || currentRefinement.max !== values.max) {
        var refineValues = values;

        if (sliderMin < min) {
          if (refineValues.min < min) {
            refineValues.min = min;
          }
        } else if (sliderMin > min) {
          if (refineValues.min === sliderMin) {
            refineValues.min = min;
          }
        }

        if (sliderMax < max) {
          if (refineValues.max === sliderMax) {
            refineValues.max = max;
          }
        } else if (sliderMax > max) {
          if (refineValues.max > max) {
            refineValues.max = max;
          }
        }

        refine(refineValues);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onValuesUpdated", function (sliderState) {
      var values = _this.extractValuesFromSliderState(sliderState);

      _this.setState({
        currentValues: values
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "extractValuesFromSliderState", function (_ref) {
      var values = _ref.values;
      return {
        min: values[0],
        max: values[1]
      };
    });

    _this.state = {
      currentValues: {
        min: props.sliderMin,
        max: props.sliderMax
      }
    };
    return _this;
  }

  _createClass(Range, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          sliderMin = _this$props2.sliderMin,
          sliderMax = _this$props2.sliderMax;
      var values = {
        min: sliderMin,
        max: sliderMax
      };
      this.setState({
        currentValues: values
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          min = _this$props3.min,
          max = _this$props3.max,
          sliderMin = _this$props3.sliderMin,
          sliderMax = _this$props3.sliderMax;
      var currentValues = this.state.currentValues;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "range-slider"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_rheostat___default.a, {
        className: "range-slider__slider",
        min: sliderMin !== undefined ? sliderMin : min,
        max: sliderMax !== undefined ? sliderMax : max,
        values: [currentValues.min, currentValues.max],
        onChange: this.onChange,
        onValuesUpdated: this.onValuesUpdated
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "range-slider__values"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "range-slider__value"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "range-slider__value-label"
      }, "Min"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "range-slider__displayed-value"
      }, currentValues.min)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "range-slider__value"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "range-slider__value-label"
      }, "Max"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "range-slider__displayed-value"
      }, currentValues.max, currentValues.max === sliderMax && "+"))));
    }
  }]);

  return Range;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Range, "propTypes", {
  min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  currentRefinement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  refine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  canRefine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  sliderMin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  sliderMax: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__["h" /* connectRange */])(Range));

/***/ }),

/***/ "./public/assets/scripts/components/products/Reset.js":
/*!************************************************************!*\
  !*** ./public/assets/scripts/components/products/Reset.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Reset =
/*#__PURE__*/
function (_Component) {
  _inherits(Reset, _Component);

  function Reset() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Reset);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Reset)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
      var _this$props = _this.props,
          refine = _this$props.refine,
          items = _this$props.items;
      refine(items);
    });

    return _this;
  }

  _createClass(Reset, [{
    key: "render",
    value: function render() {
      var linkText = this.props.linkText;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        onClick: this.handleClick
      }, linkText);
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Reset, "propTypes", {
  linkText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  refine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["f" /* connectCurrentRefinements */])(Reset));

/***/ }),

/***/ "./public/assets/scripts/components/products/ResultsRow.js":
/*!*****************************************************************!*\
  !*** ./public/assets/scripts/components/products/ResultsRow.js ***!
  \*****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_components_products_Filters__ = __webpack_require__(/*! ~/scripts/components/products/Filters */ "./public/assets/scripts/components/products/Filters.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_components_products_ProductsGrid__ = __webpack_require__(/*! ~/scripts/components/products/ProductsGrid */ "./public/assets/scripts/components/products/ProductsGrid.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var ResultsRow =
/*#__PURE__*/
function (_Component) {
  _inherits(ResultsRow, _Component);

  function ResultsRow() {
    _classCallCheck(this, ResultsRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResultsRow).apply(this, arguments));
  }

  _createClass(ResultsRow, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "results-row"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "results-row__inner"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__scripts_components_products_Filters__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__scripts_components_products_ProductsGrid__["a" /* default */], null)));
    }
  }]);

  return ResultsRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ResultsRow);

/***/ }),

/***/ "./public/assets/scripts/components/products/SearchRow.js":
/*!****************************************************************!*\
  !*** ./public/assets/scripts/components/products/SearchRow.js ***!
  \****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__ = __webpack_require__(/*! react-instantsearch-dom */ "./node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(/*! classnames */ "./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var itemsPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  items: function items() {
    return itemsPropType.apply(void 0, arguments);
  }
}));

var SearchRow =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchRow, _Component);

  function SearchRow(props) {
    var _this;

    _classCallCheck(this, SearchRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchRow).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function () {
      _this.setState({
        focused: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBlur", function () {
      _this.setState({
        focused: false
      });
    });

    _this.state = {
      focused: false,
      mobile: true
    };
    _this.handleResize = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"])(_this.handleResize.bind(_assertThisInitialized(_assertThisInitialized(_this))), 250);
    return _this;
  }

  _createClass(SearchRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          searchState = _this$props.searchState,
          refine = _this$props.refine,
          items = _this$props.items;

      if (searchState.query && searchState.query !== prevProps.searchState.query) {
        refine(items);
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var mobile = window.matchMedia("(max-width: 992px)").matches;
      this.setState({
        mobile: mobile
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          focused = _this$state.focused,
          mobile = _this$state.mobile;
      var placeholder = mobile ? "Search" : "Search for a product family, brand, application or category";
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "search-row"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()("search-box", {
          "search-box--focused": focused
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "search-box__label"
      }, "Search"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "search-box__input-wrapper"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__["e" /* SearchBox */], {
        placeholder: "Search",
        searchAsYouType: false,
        translations: {
          placeholder: placeholder
        },
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }))));
    }
  }]);

  return SearchRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(SearchRow, "propTypes", {
  searchState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  refine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  items: itemsPropType
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__["f" /* connectCurrentRefinements */])(SearchRow));

/***/ }),

/***/ "./public/assets/scripts/components/products/Searching.js":
/*!****************************************************************!*\
  !*** ./public/assets/scripts/components/products/Searching.js ***!
  \****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Searching =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Searching, _PureComponent);

  function Searching() {
    _classCallCheck(this, Searching);

    return _possibleConstructorReturn(this, _getPrototypeOf(Searching).apply(this, arguments));
  }

  _createClass(Searching, [{
    key: "render",
    value: function render() {
      var theme = this.props.theme;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "searching"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "searching__inner"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: theme === "dark" ? __webpack_require__(/*! ~/images/decorative/spinner-dark.png */ "./public/assets/images/decorative/spinner-dark.png") : __webpack_require__(/*! ~/images/decorative/spinner-light.png */ "./public/assets/images/decorative/spinner-light.png"),
        className: "searching__image"
      })));
    }
  }]);

  return Searching;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

_defineProperty(Searching, "propTypes", {
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["light", "dark"])
});

_defineProperty(Searching, "defaultProps", {
  theme: "dark"
});

/* harmony default export */ __webpack_exports__["a"] = (Searching);

/***/ }),

/***/ "./public/assets/scripts/controllers recursive \\.js$":
/*!*************************************************!*\
  !*** ./public/assets/scripts/controllers \.js$ ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./accordion_controller.js": "./public/assets/scripts/controllers/accordion_controller.js",
	"./case-studies_controller.js": "./public/assets/scripts/controllers/case-studies_controller.js",
	"./contact-form_controller.js": "./public/assets/scripts/controllers/contact-form_controller.js",
	"./dropdown_controller.js": "./public/assets/scripts/controllers/dropdown_controller.js",
	"./fly-menu_controller.js": "./public/assets/scripts/controllers/fly-menu_controller.js",
	"./home-slider_controller.js": "./public/assets/scripts/controllers/home-slider_controller.js",
	"./mobile-nav_controller.js": "./public/assets/scripts/controllers/mobile-nav_controller.js",
	"./modal_controller.js": "./public/assets/scripts/controllers/modal_controller.js",
	"./more_controller.js": "./public/assets/scripts/controllers/more_controller.js",
	"./newsletter-form_controller.js": "./public/assets/scripts/controllers/newsletter-form_controller.js",
	"./our-products_controller.js": "./public/assets/scripts/controllers/our-products_controller.js",
	"./password-form_controller.js": "./public/assets/scripts/controllers/password-form_controller.js",
	"./product-slider_controller.js": "./public/assets/scripts/controllers/product-slider_controller.js",
	"./product_controller.js": "./public/assets/scripts/controllers/product_controller.js",
	"./products-controller.js": "./public/assets/scripts/controllers/products-controller.js",
	"./scrollto_controller.js": "./public/assets/scripts/controllers/scrollto_controller.js",
	"./share_controller.js": "./public/assets/scripts/controllers/share_controller.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/assets/scripts/controllers recursive \\.js$";

/***/ }),

/***/ "./public/assets/scripts/controllers/accordion_controller.js":
/*!*******************************************************************!*\
  !*** ./public/assets/scripts/controllers/accordion_controller.js ***!
  \*******************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var CLASS_ACCORDION_ACTIVE = 'is-accordion-active';

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "opened", false);

    return _this;
  }

  _createClass(_default, [{
    key: "toggle",
    value: function toggle() {
      if (this.opened) this.close();else this.open();
    }
  }, {
    key: "open",
    value: function open() {
      if (this.opened) return;
      this.opened = true;
      this.element.classList.add(CLASS_ACCORDION_ACTIVE);
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.opened) return;
      this.opened = false;
      this.element.classList.remove(CLASS_ACCORDION_ACTIVE);
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);



/***/ }),

/***/ "./public/assets/scripts/controllers/case-studies_controller.js":
/*!**********************************************************************!*\
  !*** ./public/assets/scripts/controllers/case-studies_controller.js ***!
  \**********************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_components_CaseStudies__ = __webpack_require__(/*! ~/scripts/components/CaseStudies */ "./public/assets/scripts/components/CaseStudies.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      var pre = this.data.get("pre");
      var applications = JSON.parse(this.data.get("applications"));
      var featured = JSON.parse(this.data.get("featured"));
      var endpoint = this.data.get("endpoint");
      var props = {
        pre: pre,
        applications: applications,
        featured: featured,
        endpoint: endpoint
      };
      __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__scripts_components_CaseStudies__["a" /* default */], props), this.rootTarget);
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["root"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/contact-form_controller.js":
/*!**********************************************************************!*\
  !*** ./public/assets/scripts/controllers/contact-form_controller.js ***!
  \**********************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var CLASS_WORKING = "is-working";

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(event) {
        var form, response, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();

                if (this.validate()) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                // Collect the form data *before* disabling the inputs in startWorking()
                form = new FormData(this.element);
                this.startWorking(); // Fire Tag directly to GA server once form send has been validated

                this.sendEvent();
                _context.next = 8;
                return fetch(this.element.getAttribute("action"), {
                  method: "post",
                  headers: {
                    Accept: "application/json"
                  },
                  body: form
                });

              case 8:
                response = _context.sent;

                if (!(response.status >= 200 && response.status < 300)) {
                  _context.next = 14;
                  break;
                }

                this.element.reset();
                this.resultMessageTarget.innerHTML = "Your message has been sent.";
                _context.next = 18;
                break;

              case 14:
                _context.next = 16;
                return response.json();

              case 16:
                data = _context.sent;
                this.resultMessageTarget.innerHTML = data.message;

              case 18:
                this.finishWorking();

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submit(_x) {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: "validate",
    value: function validate() {
      var isValid = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.formRowTargets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _row = _step.value;

          _row.classList.remove("show");
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      for (var i = 0; i < this.fieldTargets.length; i++) {
        var field = this.fieldTargets[i];

        if (!field.validity.valid) {
          var row = this.formRowTargets[i];
          row.classList.add("show");
          isValid = false;
        }
      }

      return isValid;
    }
  }, {
    key: "startWorking",
    value: function startWorking() {
      // Clear the message
      this.resultMessageTarget.innerHTML = "";
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.classList.add(CLASS_WORKING);

      for (var i = 0; i < this.fieldTargets.length; i++) {
        this.fieldTargets[i].disabled = true;
      }
    }
  }, {
    key: "finishWorking",
    value: function finishWorking() {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.remove(CLASS_WORKING);

      for (var i = 0; i < this.fieldTargets.length; i++) {
        this.fieldTargets[i].disabled = false;
      }
    }
  }, {
    key: "sendEvent",
    value: function sendEvent() {
      var _window = window,
          ga = _window.ga;

      if (!ga) {
        console.warn("Google Analytics is not loaded - Can't send form submission event");
        return;
      }

      ga("send", {
        hitType: "event",
        eventCategory: "Form Interactions",
        eventAction: "Form Send",
        eventLabel: "Contact-Us Send"
      });
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["submitButton", "resultMessage", "field", "formRow"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/dropdown_controller.js":
/*!******************************************************************!*\
  !*** ./public/assets/scripts/controllers/dropdown_controller.js ***!
  \******************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_components_OpSelect__ = __webpack_require__(/*! ~/scripts/components/OpSelect */ "./public/assets/scripts/components/OpSelect.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "opened", false);

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.submit = this.submit.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      this.opSelect = new __WEBPACK_IMPORTED_MODULE_1__scripts_components_OpSelect__["a" /* default */]({
        el: this.element,
        textClass: "dropdown__text",
        textInnerClass: "dropdown__text-inner",
        select: this.selectTarget,
        onChangeCallback: this.submit
      });
    }
  }, {
    key: "submit",
    value: function submit() {
      this.formTarget.submit();
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["select", "form"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/fly-menu_controller.js":
/*!******************************************************************!*\
  !*** ./public/assets/scripts/controllers/fly-menu_controller.js ***!
  \******************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal_overlay__ = __webpack_require__(/*! ./../components/modal-overlay */ "./public/assets/scripts/components/modal-overlay.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var CLASS_MENU_ACTIVE = "is-fly-menu-active";

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "opened", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resizeTimer", void 0);

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.onResize = this.onResize.bind(this);
      this.close = this.close.bind(this);
      this.tick = this.tick.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      this.modalOverlay = new __WEBPACK_IMPORTED_MODULE_1__components_modal_overlay__["a" /* default */]({
        onClick: this.close
      });
      window.addEventListener("load", this.tick);
      window.addEventListener("resize", this.onResize);
    }
  }, {
    key: "onResize",
    value: function onResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.tick, 100);
    }
  }, {
    key: "tick",
    value: function tick() {
      var rect = this.menuTarget.getBoundingClientRect();
      this.element.style.height = "".concat(rect.height, "px");
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.opened) this.close();else this.open();
    }
  }, {
    key: "open",
    value: function open() {
      if (this.opened) return;
      this.opened = true;
      this.modalOverlay.activate();
      this.element.classList.add(CLASS_MENU_ACTIVE); // Fire virtual pageview when user clicks on the "Products" secondary navigation menu item.

      this.sendVirtualPageView("/products-menu");
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.opened) return;
      this.opened = false;
      this.modalOverlay.deactivate();
      this.element.classList.remove(CLASS_MENU_ACTIVE); // Fire virtual pageview when user closes the menu

      this.sendVirtualPageView(window.location.pathname);
    }
  }, {
    key: "sendVirtualPageView",
    value: function sendVirtualPageView(pathname) {
      var _window = window,
          ga = _window.ga;

      if (!ga) {
        console.warn("Google Analytics is not loaded - Can't send virtual page view");
        return;
      }

      ga("set", "page", pathname);
      ga("send", "pageview");
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["menu"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/home-slider_controller.js":
/*!*********************************************************************!*\
  !*** ./public/assets/scripts/controllers/home-slider_controller.js ***!
  \*********************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_components_opSlider_opSlider__ = __webpack_require__(/*! ~/scripts/components/opSlider/opSlider */ "./public/assets/scripts/components/opSlider/opSlider.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var CLASS_SELECTED = "is-selected";

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resizeTimer", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "contentWidth", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "indexHeight", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "titleHeight", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "currentIndex", 0);

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.onLoad = this.onLoad.bind(this);
      this.onResize = this.onResize.bind(this);
      this.select = this.select.bind(this);
      this.tick = this.tick.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      this.length = this.slideTargets.length;
      window.addEventListener("load", this.onLoad);
      window.addEventListener("resize", this.onResize);
    }
  }, {
    key: "onResize",
    value: function onResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.tick, 250);
    }
  }, {
    key: "tick",
    value: function tick() {
      this.contentWidth = this.contentSlideTargets[0].offsetWidth;
      this.indexHeight = this.indexTargets[0].offsetHeight;
      this.titleHeight = this.titleTargets[0].offsetHeight;
      this.select(this.currentIndex);
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      this.tick();
      var config = {
        slider: this.sliderTarget,
        frame: this.frameTarget,
        list: this.listTarget,
        slides: this.slideTargets,
        nextItems: this.hasRightTarget ? [this.rightTarget] : null,
        prevItems: this.hasLeftTarget ? [this.leftTarget] : null,
        onSelect: this.select,
        animationAllowed: false,
        mode: {}
      };

      if (window.innerWidth > 768) {
        config.dragAllowed = false;
      } else {
        config.dragAllowed = true;
      } // this.select(0);


      this.slider = new __WEBPACK_IMPORTED_MODULE_1__scripts_components_opSlider_opSlider__["a" /* default */](config);
    }
  }, {
    key: "select",
    value: function select(index) {
      this.currentIndex = index;
      this.contentListTarget.style.transform = "translate3d(".concat(index * this.contentWidth, "px, 0, 0)");
      this.indexListTarget.style.transform = "translateY(-".concat(index * this.indexHeight, "px)");
      this.titleListTarget.style.transform = "translateY(-".concat(index * this.titleHeight, "px)"); // console.log(index);

      for (var i = 0; i < this.length; i++) {
        this.indexTargets[i].classList.remove(CLASS_SELECTED);
        this.titleTargets[i].classList.remove(CLASS_SELECTED);
        this.contentSlideTargets[i].classList.remove(CLASS_SELECTED);
      }

      this.indexTargets[index].classList.add(CLASS_SELECTED);
      this.titleTargets[index].classList.add(CLASS_SELECTED);
      this.contentSlideTargets[index].classList.add(CLASS_SELECTED);
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["slider", "frame", "list", "slide", "left", "right", "indexList", "index", "titleList", "title", "contentList", "contentSlide"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/mobile-nav_controller.js":
/*!********************************************************************!*\
  !*** ./public/assets/scripts/controllers/mobile-nav_controller.js ***!
  \********************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal_overlay__ = __webpack_require__(/*! ./../components/modal-overlay */ "./public/assets/scripts/components/modal-overlay.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_body__ = __webpack_require__(/*! ./../components/body */ "./public/assets/scripts/components/body.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var CLASS_MENU_ACTIVE = 'is-mobile-menu-active';
var CLASS_DROPDOWN_ACTIVE = 'is-dropdown-active';

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "opened", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dropdownOpened", false);

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.close = this.close.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      this.modalOverlay = new __WEBPACK_IMPORTED_MODULE_1__components_modal_overlay__["a" /* default */]({
        onClick: this.close
      });
      this.body = new __WEBPACK_IMPORTED_MODULE_2__components_body__["a" /* default */]();
    }
  }, {
    key: "open",
    value: function open() {
      if (this.opened) return;
      this.opened = true;
      this.modalOverlay.activate();
      this.element.classList.add(CLASS_MENU_ACTIVE);
      this.body.disableScroll();
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.opened) return;
      this.opened = false;
      this.modalOverlay.deactivate();
      this.element.classList.remove(CLASS_MENU_ACTIVE);
      this.body.enableScroll();
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      if (this.dropdownOpened) {
        this.dropdownOpened = false;
        this.dropdownTarget.classList.remove(CLASS_DROPDOWN_ACTIVE);
      } else {
        this.dropdownOpened = true;
        this.dropdownTarget.classList.add(CLASS_DROPDOWN_ACTIVE);
      }
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ['dropdown']);



/***/ }),

/***/ "./public/assets/scripts/controllers/modal_controller.js":
/*!***************************************************************!*\
  !*** ./public/assets/scripts/controllers/modal_controller.js ***!
  \***************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_components_ProductModal__ = __webpack_require__(/*! ~/scripts/components/ProductModal */ "./public/assets/scripts/components/ProductModal.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var CLASS_BODY_DISABLED = "is-scroll-disabled";

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCrossClick", function () {
      _this.close();
    });

    return _this;
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      this.render(false);
    }
  }, {
    key: "open",
    value: function open(event) {
      this.selected = window.variations[event.target.dataset.id];
      document.body.classList.add(CLASS_BODY_DISABLED);
      this.render(true);
    }
  }, {
    key: "close",
    value: function close() {
      document.body.classList.remove(CLASS_BODY_DISABLED);
      this.render(false);
    }
  }, {
    key: "render",
    value: function render(active) {
      __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__scripts_components_ProductModal__["a" /* default */], _extends({
        active: active,
        onCrossClick: this.handleCrossClick,
        familyDownloads: window.familyDownloads
      }, this.selected)), this.rootTarget);
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["root"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/more_controller.js":
/*!**************************************************************!*\
  !*** ./public/assets/scripts/controllers/more_controller.js ***!
  \**************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      if (this.hasReadMoreTarget) {
        this.readMoreTarget.classList.remove("hide");
        var elements = this.element.querySelectorAll(".rich-text");

        for (var i = 0; i < elements.length; i++) {
          if (i > 0) {
            elements[i].classList.add("hide");
          }
        }
      }
    }
  }, {
    key: "readMore",
    value: function readMore() {
      if (this.hasReadMoreTarget) {
        this.readMoreTarget.classList.add("hide");
        var elements = this.element.querySelectorAll(".rich-text.hide");
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var hidden = _step.value;
            hidden.classList.remove("hide");
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["readMore"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/newsletter-form_controller.js":
/*!*************************************************************************!*\
  !*** ./public/assets/scripts/controllers/newsletter-form_controller.js ***!
  \*************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var CLASS_WORKING = "is-working";

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(event) {
        var form, response, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();

                if (this.validate()) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                // Collect the form data *before* disabling the inputs in startWorking()
                form = new FormData(this.element);
                this.startWorking(); // Fire Tag directly to GA server once form send has been validated

                this.sendEvent();
                _context.next = 8;
                return fetch(this.element.action, {
                  method: "post",
                  body: form
                });

              case 8:
                response = _context.sent;
                _context.next = 11;
                return response.json();

              case 11:
                data = _context.sent;
                this.resultMessageTarget.innerHTML = data.message;

                if (response.status >= 200 && response.status < 300) {
                  this.element.reset();
                }

                this.finishWorking();

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submit(_x) {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: "validate",
    value: function validate() {
      var isValid = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.formRowTargets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _row = _step.value;

          _row.classList.remove("show");
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      for (var i = 0; i < this.fieldTargets.length; i++) {
        var field = this.fieldTargets[i];

        if (!field.validity.valid) {
          var row = this.formRowTargets[i];
          row.classList.add("show");
          isValid = false;
        }
      }

      return isValid;
    }
  }, {
    key: "startWorking",
    value: function startWorking() {
      // Clear the message
      this.resultMessageTarget.innerHTML = "";
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.classList.add(CLASS_WORKING);

      for (var i = 0; i < this.fieldTargets.length; i++) {
        this.fieldTargets[i].disabled = true;
      }
    }
  }, {
    key: "finishWorking",
    value: function finishWorking() {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.remove(CLASS_WORKING);

      for (var i = 0; i < this.fieldTargets.length; i++) {
        this.fieldTargets[i].disabled = false;
      }
    }
  }, {
    key: "sendEvent",
    value: function sendEvent() {
      var _window = window,
          ga = _window.ga;

      if (!ga) {
        console.warn("Google Analytics is not loaded - Can't send form submission event");
        return;
      }

      ga("send", {
        hitType: "event",
        eventCategory: "Form Interactions",
        eventAction: "Form Send",
        eventLabel: "Email Subscription"
      });
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["submitButton", "resultMessage", "field", "formRow"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/our-products_controller.js":
/*!**********************************************************************!*\
  !*** ./public/assets/scripts/controllers/our-products_controller.js ***!
  \**********************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_impetus__ = __webpack_require__(/*! impetus */ "./node_modules/impetus/dist/impetus.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_impetus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_impetus__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var CLASS_IS_LOCKED = "is-locked";
var CLASS_SECTION_WRAPPER_WITH_BUTTON = "section-wrapper--with-button";
var NUMBER_OF_ROWS_TO_LIMIT = 6;

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTouch", function () {
      _this.productTable = _this.productTable.destroy();
      window.removeEventListener("touchstart", _this.handleTouch);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "preventDefault", function (event) {
      event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLoad", function () {
      if (_this.rowTargets.length > NUMBER_OF_ROWS_TO_LIMIT) {
        _this.lock();
      } else {
        _this.release();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScroll", function () {
      var scrollLeft = _this.scrollerTarget.scrollLeft;

      _this.productTable.setValues(-scrollLeft);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setScroll", function (x) {
      _this.scrollerTarget.scrollLeft = -x;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lock", function () {
      var headerHeight = _this.headerTarget.offsetHeight;
      var rowHeight = _this.rowTargets[0].offsetHeight;
      _this.scrollerTarget.style.overflowY = "hidden";
      _this.scrollerTarget.style.maxHeight = "".concat(rowHeight * (NUMBER_OF_ROWS_TO_LIMIT + 0.5) + headerHeight, "px");

      _this.element.classList.add(CLASS_SECTION_WRAPPER_WITH_BUTTON);

      _this.buttonTarget.parentElement.classList.add(CLASS_IS_LOCKED);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "release", function () {
      _this.scrollerTarget.style.overflowY = "";
      _this.scrollerTarget.style.maxHeight = "";

      _this.element.classList.remove(CLASS_SECTION_WRAPPER_WITH_BUTTON);

      _this.buttonTarget.parentElement.classList.remove(CLASS_IS_LOCKED);
    });

    return _this;
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      window.addEventListener("load", this.handleLoad);
      window.addEventListener("touchstart", this.handleTouch);
      this.productTable = new __WEBPACK_IMPORTED_MODULE_1_impetus___default.a({
        source: this.scrollerTarget,
        update: this.setScroll
      });
      this.tableTarget.addEventListener("mousedown", this.preventDefault);
      this.scrollerTarget.addEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      window.removeEventListener("load", this.handleLoad);
      window.removeEventListener("touchstart", this.handleTouch);
      this.productTable = this.productTable.destroy();
      this.tableTarget.removeEventListener("mousedown", this.preventDefault);
      this.scrollerTarget.removeEventListener("scroll", this.handleScroll);
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["table", "scroller", "button", "header", "row"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/password-form_controller.js":
/*!***********************************************************************!*\
  !*** ./public/assets/scripts/controllers/password-form_controller.js ***!
  \***********************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var CLASS_WORKING = "is-working";

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "submit",
    value: function submit(event) {
      event.preventDefault();

      if (!this.validate()) {
        return;
      }

      this.startWorking();
      this.element.submit();
    }
  }, {
    key: "validate",
    value: function validate() {
      var isValid = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.formRowTargets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _row = _step.value;

          _row.classList.remove("show");
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      for (var i = 0; i < this.fieldTargets.length; i++) {
        var field = this.fieldTargets[i];

        if (!field.validity.valid) {
          var row = this.formRowTargets[i];
          row.classList.add("show");
          isValid = false;
        }
      }

      return isValid;
    }
  }, {
    key: "startWorking",
    value: function startWorking() {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.classList.add(CLASS_WORKING);
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["submitButton", "field", "formRow"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/product-slider_controller.js":
/*!************************************************************************!*\
  !*** ./public/assets/scripts/controllers/product-slider_controller.js ***!
  \************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_components_opSlider_opSlider__ = __webpack_require__(/*! ~/scripts/components/opSlider/opSlider */ "./public/assets/scripts/components/opSlider/opSlider.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var CLASS_SELECTED = "is-selected";
var CLEAR_CHECK = "product-slider__slide--clear-cut";
var IS_CLEAR = "is-clear-cut";

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectedIndex", null);

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.onLoad = this.onLoad.bind(this);
      this.select = this.select.bind(this);
      this.imageSlide = this.imageSlide.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      this.onLoad();
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      this.select(0);
      this.thumbSlider = new __WEBPACK_IMPORTED_MODULE_1__scripts_components_opSlider_opSlider__["a" /* default */]({
        slider: this.thumbSliderTarget,
        frame: this.thumbFrameTarget,
        list: this.thumbListTarget,
        slides: this.thumbSlideTargets,
        mode: {
          // centered: true,
          fill: true,
          // infinite: true,
          multiple: true // loop: true,
          // autoplay: {
          //     duration: 4000,
          //     pauseOnHover: true,
          // },

        }
      });
      this.imageSlider = new __WEBPACK_IMPORTED_MODULE_1__scripts_components_opSlider_opSlider__["a" /* default */]({
        slider: this.sliderTarget,
        frame: this.frameTarget,
        list: this.listTarget,
        slides: this.slideTargets,
        onSelect: this.imageSlide,
        animationAllowed: false,
        dragAllowed: true,
        mode: {}
      });
    }
  }, {
    key: "dotClick",
    value: function dotClick(event) {
      var index = parseInt(event.target.getAttribute("data-index")) - 1;
      this.thumbSlider.select(index);
      this.imageSlider.select(index);
      this.select(index);
    }
  }, {
    key: "imageSlide",
    value: function imageSlide(index) {
      this.thumbSlider.select(index);
      this.select(index);
    }
  }, {
    key: "thumbClick",
    value: function thumbClick(event) {
      var index = parseInt(event.currentTarget.getAttribute("data-index")) - 1;
      this.select(index);
    }
  }, {
    key: "select",
    value: function select(index) {
      if (this.selectedIndex === index) return;
      this.selectedIndex = index;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.dotTargets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var target = _step.value;
          target.classList.remove(CLASS_SELECTED);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.thumbSlideTargets[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _target = _step2.value;

          _target.classList.remove(CLASS_SELECTED);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.slideTargets[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _target2 = _step3.value;

          _target2.classList.remove(CLASS_SELECTED);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.captionTargets[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _target3 = _step4.value;

          _target3.classList.remove(CLASS_SELECTED);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var dotTarget = this.dotTargets[this.selectedIndex];

      if (dotTarget) {
        dotTarget.classList.add(CLASS_SELECTED);
      }

      var currentSlide = this.slideTargets[this.selectedIndex];

      if (currentSlide.classList.contains(CLEAR_CHECK)) {
        this.clearCutTarget.classList.add(IS_CLEAR);
      } else {
        this.clearCutTarget.classList.remove(IS_CLEAR);
      }

      this.thumbSlideTargets[this.selectedIndex].classList.add(CLASS_SELECTED);
      this.slideTargets[this.selectedIndex].classList.add(CLASS_SELECTED);
      this.captionTargets[this.selectedIndex].classList.add(CLASS_SELECTED);
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["slider", "frame", "list", "clearCut", "slide", "dot", "thumbSlider", "thumbFrame", "thumbList", "thumbSlide", "caption"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/product_controller.js":
/*!*****************************************************************!*\
  !*** ./public/assets/scripts/controllers/product_controller.js ***!
  \*****************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      this.recordImpression();
    }
  }, {
    key: "recordImpression",
    value: function recordImpression() {
      var name = this.data.get("name");
      var category = this.data.get("category");
      var brand = this.data.get("brand");
      var _window = window,
          ga = _window.ga;

      if (!ga) {
        console.warn("Google Analytics is not loaded - Can't track product detail impression");
        return;
      } // Requiring Enhanced Ecommerce plugin stops queue execution so we know
      // that the other commands after will execute when the tracker is ready


      ga("require", "ec", "ec.js");
      ga("ec:addProduct", {
        name: name,
        category: category,
        brand: brand
      });
      ga("ec:setAction", "detail");
      ga("send", {
        hitType: "event",
        eventCategory: "Product",
        eventAction: "View"
      }); // Send product details
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);



/***/ }),

/***/ "./public/assets/scripts/controllers/products-controller.js":
/*!******************************************************************!*\
  !*** ./public/assets/scripts/controllers/products-controller.js ***!
  \******************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_components_Products__ = __webpack_require__(/*! ~/scripts/components/Products */ "./public/assets/scripts/components/Products.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__scripts_components_Products__["a" /* default */], null), this.element);
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);



/***/ }),

/***/ "./public/assets/scripts/controllers/scrollto_controller.js":
/*!******************************************************************!*\
  !*** ./public/assets/scripts/controllers/scrollto_controller.js ***!
  \******************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_components_OpSelect__ = __webpack_require__(/*! ~/scripts/components/OpSelect */ "./public/assets/scripts/components/OpSelect.js");
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "opened", false);

    return _this;
  }

  _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.scrollTo = this.scrollTo.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      this.opSelect = new __WEBPACK_IMPORTED_MODULE_1__scripts_components_OpSelect__["a" /* default */]({
        el: this.dropdownTarget,
        textClass: "dropdown__text",
        textInnerClass: "dropdown__text-inner",
        select: this.selectTarget,
        onChangeCallback: this.scrollTo
      });
    }
  }, {
    key: "calculateScrollOffset",
    value: function calculateScrollOffset(elem, additionalOffset, alignment) {
      var body = document.body,
          html = document.documentElement;
      var elemRect = elem.getBoundingClientRect();
      var clientHeight = html.clientHeight;
      var documentHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
      additionalOffset = additionalOffset || 0;
      var scrollPosition;

      if (alignment === "bottom") {
        scrollPosition = elemRect.bottom - clientHeight;
      } else if (alignment === "middle") {
        scrollPosition = elemRect.bottom - clientHeight / 2 - elemRect.height / 2;
      } else {
        // top and default
        scrollPosition = elemRect.top;
      }

      var maxScrollPosition = documentHeight - clientHeight;
      return Math.min(scrollPosition + additionalOffset + window.pageYOffset, maxScrollPosition);
    }
  }, {
    key: "scrollTo",
    value: function scrollTo() {
      var el = this.sectionTargets[this.opSelect.select.selectedIndex - 1];

      if (el) {
        var t = this.calculateScrollOffset(el, -100, "top");
        window.scrollTo({
          top: t,
          behavior: "smooth"
        });
      }
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);

_defineProperty(_default, "targets", ["dropdown", "select", "section"]);



/***/ }),

/***/ "./public/assets/scripts/controllers/share_controller.js":
/*!***************************************************************!*\
  !*** ./public/assets/scripts/controllers/share_controller.js ***!
  \***************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stimulus__ = __webpack_require__(/*! stimulus */ "./node_modules/stimulus/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard_copy__ = __webpack_require__(/*! clipboard-copy */ "./node_modules/clipboard-copy/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard_copy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard_copy__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "print",
    value: function print() {
      window.print();
    }
  }, {
    key: "copy",
    value: function copy() {
      __WEBPACK_IMPORTED_MODULE_1_clipboard_copy___default()(window.location.href).then(function () {
        alert("Page link copied.");
      }).catch(function () {
        alert("There was a problem copying the page link. Please try again.");
      });
    }
  }]);

  return _default;
}(__WEBPACK_IMPORTED_MODULE_0_stimulus__["b" /* Controller */]);



/***/ }),

/***/ "./public/assets/scripts/helpers/AF.js":
/*!*********************************************!*\
  !*** ./public/assets/scripts/helpers/AF.js ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AF =
/*#__PURE__*/
function () {
  _createClass(AF, null, [{
    key: "instance",
    value: function instance() {
      if (this._instance) return this._instance;
      return this._instance = new this();
    }
  }]);

  function AF() {
    _classCallCheck(this, AF);

    _defineProperty(this, "_instance", void 0);

    _defineProperty(this, "_frame", null);

    _defineProperty(this, "_stopped", true);

    _defineProperty(this, "_oneRead", []);

    _defineProperty(this, "_oneWrite", []);

    _defineProperty(this, "_read", []);

    _defineProperty(this, "_write", []);

    this._animate = this._animate.bind(this);
    if (typeof window !== 'undefined') this.start();
  }

  _createClass(AF, [{
    key: "start",
    value: function start() {
      if (!this._stopped) return;
      this._stopped = false;

      this._animate();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this._stopped) return;
      this._stopped = true;
      window.cancelAnimationFrame(this._frame);
    }
  }, {
    key: "_animate",
    value: function _animate() {
      var oW = this._oneWrite,
          oR = this._oneRead,
          r = this._read,
          w = this._write;
      var i; // do one read, remove and trigger; then trigger loop reads

      while (oR.length) {
        oR.shift()();
      }

      for (i = 0; i < r.length; i++) {
        r[i]();
      } // do one write, remove and trigger; then trigger loop writes


      while (oW.length) {
        oW.shift()();
      }

      for (i = 0; i < w.length; i++) {
        w[i]();
      }

      this._frame = window.requestAnimationFrame(this._animate);
    }
  }, {
    key: "onNextRead",
    value: function onNextRead(fn) {
      this._oneRead.push(fn);
    }
  }, {
    key: "onNextWrite",
    value: function onNextWrite(fn) {
      this._oneWrite.push(fn);
    }
  }, {
    key: "addRead",
    value: function addRead(fn) {
      this._read.push(fn);
    }
  }, {
    key: "addWrite",
    value: function addWrite(fn) {
      this._write.push(fn);
    }
  }, {
    key: "removeRead",
    value: function removeRead(fn) {
      var r = this._read,
          l = r.length;

      for (var i = 0; i < l; i++) {
        if (r[i] === fn) r.splice(i, 1);
      }
    }
  }, {
    key: "removeWrite",
    value: function removeWrite(fn) {
      var w = this._write,
          l = w.length;

      for (var i = 0; i < l; i++) {
        if (w[i] === fn) w.splice(i, 1);
      }
    }
  }]);

  return AF;
}();

/* harmony default export */ __webpack_exports__["a"] = (AF);

/***/ }),

/***/ "./public/assets/scripts/helpers/bezier-easing.js":
/*!********************************************************!*\
  !*** ./public/assets/scripts/helpers/bezier-easing.js ***!
  \********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bezier;
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */
// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
var float32ArraySupported = typeof Float32Array === 'function';

function A(aA1, aA2) {
  return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}

function B(aA1, aA2) {
  return 3.0 * aA2 - 6.0 * aA1;
}

function C(aA1) {
  return 3.0 * aA1;
} // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


function calcBezier(aT, aA1, aA2) {
  return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
} // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


function getSlope(aT, aA1, aA2) {
  return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
}

function binarySubdivide(aX, aA, aB, mX1, mX2) {
  var currentX,
      currentT,
      i = 0;

  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;

    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

  return currentT;
}

function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
  for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
    var currentSlope = getSlope(aGuessT, mX1, mX2);

    if (currentSlope === 0.0) {
      return aGuessT;
    }

    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
    aGuessT -= currentX / currentSlope;
  }

  return aGuessT;
}

function bezier(mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  } // Precompute samples table


  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);

  if (mX1 !== mY1 || mX2 !== mY2) {
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }

  function getTForX(aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }

    --currentSample; // Interpolate to provide an initial guess for t

    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;
    var initialSlope = getSlope(guessForT, mX1, mX2);

    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing(x) {
    if (mX1 === mY1 && mX2 === mY2) {
      return x; // linear
    } // Because JavaScript number are imprecise, we should guarantee the extremes are right.


    if (x === 0) {
      return 0;
    }

    if (x === 1) {
      return 1;
    }

    return calcBezier(getTForX(x), mY1, mY2);
  };
}
;

/***/ }),

/***/ "./public/assets/scripts/helpers/is-mobile.js":
/*!****************************************************!*\
  !*** ./public/assets/scripts/helpers/is-mobile.js ***!
  \****************************************************/
/*! exports provided: checkMobile, mobileAndTabletcheck, isMobile */
/*! exports used: isMobile */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkMobile */
/* unused harmony export mobileAndTabletcheck */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isMobile; });
function checkMobile() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var MOBILE_WINDOW = /windows phone/i.test(userAgent);
  var MOBILE_ANDROID = /android/i.test(userAgent);
  var MOBILE_IOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  return MOBILE_IOS || MOBILE_ANDROID || MOBILE_WINDOW;
}
var mobileAndTabletcheck = function mobileAndTabletcheck() {
  var check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};
var isMobile = checkMobile();

/***/ }),

/***/ "./public/assets/scripts/helpers/rect.js":
/*!***********************************************!*\
  !*** ./public/assets/scripts/helpers/rect.js ***!
  \***********************************************/
/*! exports provided: Rect */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Rect */
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Rect =
/*#__PURE__*/
function () {
  function Rect(_ref) {
    var el = _ref.el;

    _classCallCheck(this, Rect);

    this.el = el;
    this.tick();
  }

  _createClass(Rect, [{
    key: "tick",
    value: function tick() {
      var rect = this.el.getBoundingClientRect();
      this.top = rect.top;
      this.right = rect.right;
      this.bottom = rect.bottom;
      this.left = rect.left;
      this.height = rect.height;
      this.width = rect.width;
      this.winHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }
  }, {
    key: "progress",
    get: function get() {
      return 1 - (this.top + this.height) / (this.winHeight + this.height);
    }
  }, {
    key: "altProgress",
    get: function get() {
      return 1 - (this.top + this.height) / this.height;
    }
  }]);

  return Rect;
}();

/***/ }),

/***/ "./public/assets/scripts/main.js":
/*!***************************************!*\
  !*** ./public/assets/scripts/main.js ***!
  \***************************************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_copy_within__ = __webpack_require__(/*! core-js/modules/es6.array.copy-within */ "./node_modules/core-js/modules/es6.array.copy-within.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_every__ = __webpack_require__(/*! core-js/modules/es6.array.every */ "./node_modules/core-js/modules/es6.array.every.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_fill__ = __webpack_require__(/*! core-js/modules/es6.array.fill */ "./node_modules/core-js/modules/es6.array.fill.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter__ = __webpack_require__(/*! core-js/modules/es6.array.filter */ "./node_modules/core-js/modules/es6.array.filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_find__ = __webpack_require__(/*! core-js/modules/es6.array.find */ "./node_modules/core-js/modules/es6.array.find.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_index__ = __webpack_require__(/*! core-js/modules/es6.array.find-index */ "./node_modules/core-js/modules/es6.array.find-index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each__ = __webpack_require__(/*! core-js/modules/es6.array.for-each */ "./node_modules/core-js/modules/es6.array.for-each.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_from__ = __webpack_require__(/*! core-js/modules/es6.array.from */ "./node_modules/core-js/modules/es6.array.from.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes__ = __webpack_require__(/*! core-js/modules/es7.array.includes */ "./node_modules/core-js/modules/es7.array.includes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of__ = __webpack_require__(/*! core-js/modules/es6.array.index-of */ "./node_modules/core-js/modules/es6.array.index-of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_is_array__ = __webpack_require__(/*! core-js/modules/es6.array.is-array */ "./node_modules/core-js/modules/es6.array.is-array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_is_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_is_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator__ = __webpack_require__(/*! core-js/modules/es6.array.iterator */ "./node_modules/core-js/modules/es6.array.iterator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_last_index_of__ = __webpack_require__(/*! core-js/modules/es6.array.last-index-of */ "./node_modules/core-js/modules/es6.array.last-index-of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_last_index_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_last_index_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_map__ = __webpack_require__(/*! core-js/modules/es6.array.map */ "./node_modules/core-js/modules/es6.array.map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_of__ = __webpack_require__(/*! core-js/modules/es6.array.of */ "./node_modules/core-js/modules/es6.array.of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_reduce__ = __webpack_require__(/*! core-js/modules/es6.array.reduce */ "./node_modules/core-js/modules/es6.array.reduce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_reduce_right__ = __webpack_require__(/*! core-js/modules/es6.array.reduce-right */ "./node_modules/core-js/modules/es6.array.reduce-right.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_reduce_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_reduce_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_some__ = __webpack_require__(/*! core-js/modules/es6.array.some */ "./node_modules/core-js/modules/es6.array.some.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_sort__ = __webpack_require__(/*! core-js/modules/es6.array.sort */ "./node_modules/core-js/modules/es6.array.sort.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_sort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_species__ = __webpack_require__(/*! core-js/modules/es6.array.species */ "./node_modules/core-js/modules/es6.array.species.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_species___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_species__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_date_now__ = __webpack_require__(/*! core-js/modules/es6.date.now */ "./node_modules/core-js/modules/es6.date.now.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_date_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_date_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_date_to_iso_string__ = __webpack_require__(/*! core-js/modules/es6.date.to-iso-string */ "./node_modules/core-js/modules/es6.date.to-iso-string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_date_to_iso_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_date_to_iso_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_date_to_json__ = __webpack_require__(/*! core-js/modules/es6.date.to-json */ "./node_modules/core-js/modules/es6.date.to-json.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_date_to_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_date_to_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_date_to_primitive__ = __webpack_require__(/*! core-js/modules/es6.date.to-primitive */ "./node_modules/core-js/modules/es6.date.to-primitive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_date_to_primitive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_date_to_primitive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_date_to_string__ = __webpack_require__(/*! core-js/modules/es6.date.to-string */ "./node_modules/core-js/modules/es6.date.to-string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_date_to_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_date_to_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_function_bind__ = __webpack_require__(/*! core-js/modules/es6.function.bind */ "./node_modules/core-js/modules/es6.function.bind.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_function_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_function_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_function_has_instance__ = __webpack_require__(/*! core-js/modules/es6.function.has-instance */ "./node_modules/core-js/modules/es6.function.has-instance.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_function_has_instance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_function_has_instance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_function_name__ = __webpack_require__(/*! core-js/modules/es6.function.name */ "./node_modules/core-js/modules/es6.function.name.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_map__ = __webpack_require__(/*! core-js/modules/es6.map */ "./node_modules/core-js/modules/es6.map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_math_acosh__ = __webpack_require__(/*! core-js/modules/es6.math.acosh */ "./node_modules/core-js/modules/es6.math.acosh.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_math_asinh__ = __webpack_require__(/*! core-js/modules/es6.math.asinh */ "./node_modules/core-js/modules/es6.math.asinh.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_math_atanh__ = __webpack_require__(/*! core-js/modules/es6.math.atanh */ "./node_modules/core-js/modules/es6.math.atanh.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_math_cbrt__ = __webpack_require__(/*! core-js/modules/es6.math.cbrt */ "./node_modules/core-js/modules/es6.math.cbrt.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_math_clz32__ = __webpack_require__(/*! core-js/modules/es6.math.clz32 */ "./node_modules/core-js/modules/es6.math.clz32.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_math_cosh__ = __webpack_require__(/*! core-js/modules/es6.math.cosh */ "./node_modules/core-js/modules/es6.math.cosh.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_math_expm1__ = __webpack_require__(/*! core-js/modules/es6.math.expm1 */ "./node_modules/core-js/modules/es6.math.expm1.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_math_fround__ = __webpack_require__(/*! core-js/modules/es6.math.fround */ "./node_modules/core-js/modules/es6.math.fround.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_math_hypot__ = __webpack_require__(/*! core-js/modules/es6.math.hypot */ "./node_modules/core-js/modules/es6.math.hypot.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_math_imul__ = __webpack_require__(/*! core-js/modules/es6.math.imul */ "./node_modules/core-js/modules/es6.math.imul.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_math_log1p__ = __webpack_require__(/*! core-js/modules/es6.math.log1p */ "./node_modules/core-js/modules/es6.math.log1p.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_math_log10__ = __webpack_require__(/*! core-js/modules/es6.math.log10 */ "./node_modules/core-js/modules/es6.math.log10.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_math_log2__ = __webpack_require__(/*! core-js/modules/es6.math.log2 */ "./node_modules/core-js/modules/es6.math.log2.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_math_sign__ = __webpack_require__(/*! core-js/modules/es6.math.sign */ "./node_modules/core-js/modules/es6.math.sign.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_math_sinh__ = __webpack_require__(/*! core-js/modules/es6.math.sinh */ "./node_modules/core-js/modules/es6.math.sinh.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_math_tanh__ = __webpack_require__(/*! core-js/modules/es6.math.tanh */ "./node_modules/core-js/modules/es6.math.tanh.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_math_trunc__ = __webpack_require__(/*! core-js/modules/es6.math.trunc */ "./node_modules/core-js/modules/es6.math.trunc.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_number_constructor__ = __webpack_require__(/*! core-js/modules/es6.number.constructor */ "./node_modules/core-js/modules/es6.number.constructor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_number_constructor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_number_constructor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_number_epsilon__ = __webpack_require__(/*! core-js/modules/es6.number.epsilon */ "./node_modules/core-js/modules/es6.number.epsilon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_number_is_finite__ = __webpack_require__(/*! core-js/modules/es6.number.is-finite */ "./node_modules/core-js/modules/es6.number.is-finite.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_number_is_integer__ = __webpack_require__(/*! core-js/modules/es6.number.is-integer */ "./node_modules/core-js/modules/es6.number.is-integer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_number_is_nan__ = __webpack_require__(/*! core-js/modules/es6.number.is-nan */ "./node_modules/core-js/modules/es6.number.is-nan.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(/*! core-js/modules/es6.number.is-safe-integer */ "./node_modules/core-js/modules/es6.number.is-safe-integer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(/*! core-js/modules/es6.number.max-safe-integer */ "./node_modules/core-js/modules/es6.number.max-safe-integer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(/*! core-js/modules/es6.number.min-safe-integer */ "./node_modules/core-js/modules/es6.number.min-safe-integer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_parse_float__ = __webpack_require__(/*! core-js/modules/es6.number.parse-float */ "./node_modules/core-js/modules/es6.number.parse-float.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_parse_int__ = __webpack_require__(/*! core-js/modules/es6.number.parse-int */ "./node_modules/core-js/modules/es6.number.parse-int.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_object_assign__ = __webpack_require__(/*! core-js/modules/es6.object.assign */ "./node_modules/core-js/modules/es6.object.assign.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_object_create__ = __webpack_require__(/*! core-js/modules/es6.object.create */ "./node_modules/core-js/modules/es6.object.create.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es7_object_define_getter__ = __webpack_require__(/*! core-js/modules/es7.object.define-getter */ "./node_modules/core-js/modules/es7.object.define-getter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es7_object_define_getter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es7_object_define_getter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es7_object_define_setter__ = __webpack_require__(/*! core-js/modules/es7.object.define-setter */ "./node_modules/core-js/modules/es7.object.define-setter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es7_object_define_setter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es7_object_define_setter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_object_define_property__ = __webpack_require__(/*! core-js/modules/es6.object.define-property */ "./node_modules/core-js/modules/es6.object.define-property.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_object_define_properties__ = __webpack_require__(/*! core-js/modules/es6.object.define-properties */ "./node_modules/core-js/modules/es6.object.define-properties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es7_object_entries__ = __webpack_require__(/*! core-js/modules/es7.object.entries */ "./node_modules/core-js/modules/es7.object.entries.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_object_freeze__ = __webpack_require__(/*! core-js/modules/es6.object.freeze */ "./node_modules/core-js/modules/es6.object.freeze.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_object_get_own_property_descriptor__ = __webpack_require__(/*! core-js/modules/es6.object.get-own-property-descriptor */ "./node_modules/core-js/modules/es6.object.get-own-property-descriptor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(/*! core-js/modules/es7.object.get-own-property-descriptors */ "./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_object_get_own_property_names__ = __webpack_require__(/*! core-js/modules/es6.object.get-own-property-names */ "./node_modules/core-js/modules/es6.object.get-own-property-names.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_object_get_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.object.get-prototype-of */ "./node_modules/core-js/modules/es6.object.get-prototype-of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es7_object_lookup_getter__ = __webpack_require__(/*! core-js/modules/es7.object.lookup-getter */ "./node_modules/core-js/modules/es7.object.lookup-getter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es7_object_lookup_getter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es7_object_lookup_getter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es7_object_lookup_setter__ = __webpack_require__(/*! core-js/modules/es7.object.lookup-setter */ "./node_modules/core-js/modules/es7.object.lookup-setter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es7_object_lookup_setter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es7_object_lookup_setter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_object_prevent_extensions__ = __webpack_require__(/*! core-js/modules/es6.object.prevent-extensions */ "./node_modules/core-js/modules/es6.object.prevent-extensions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_object_is__ = __webpack_require__(/*! core-js/modules/es6.object.is */ "./node_modules/core-js/modules/es6.object.is.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_object_is_frozen__ = __webpack_require__(/*! core-js/modules/es6.object.is-frozen */ "./node_modules/core-js/modules/es6.object.is-frozen.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_object_is_frozen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_object_is_frozen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_object_is_sealed__ = __webpack_require__(/*! core-js/modules/es6.object.is-sealed */ "./node_modules/core-js/modules/es6.object.is-sealed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_object_is_sealed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_object_is_sealed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_object_is_extensible__ = __webpack_require__(/*! core-js/modules/es6.object.is-extensible */ "./node_modules/core-js/modules/es6.object.is-extensible.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_object_keys__ = __webpack_require__(/*! core-js/modules/es6.object.keys */ "./node_modules/core-js/modules/es6.object.keys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_object_seal__ = __webpack_require__(/*! core-js/modules/es6.object.seal */ "./node_modules/core-js/modules/es6.object.seal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_object_seal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_object_seal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ "./node_modules/core-js/modules/es6.object.set-prototype-of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_values__ = __webpack_require__(/*! core-js/modules/es7.object.values */ "./node_modules/core-js/modules/es7.object.values.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_promise__ = __webpack_require__(/*! core-js/modules/es6.promise */ "./node_modules/core-js/modules/es6.promise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_promise_finally__ = __webpack_require__(/*! core-js/modules/es7.promise.finally */ "./node_modules/core-js/modules/es7.promise.finally.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_promise_finally___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_promise_finally__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_reflect_apply__ = __webpack_require__(/*! core-js/modules/es6.reflect.apply */ "./node_modules/core-js/modules/es6.reflect.apply.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_reflect_construct__ = __webpack_require__(/*! core-js/modules/es6.reflect.construct */ "./node_modules/core-js/modules/es6.reflect.construct.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_reflect_define_property__ = __webpack_require__(/*! core-js/modules/es6.reflect.define-property */ "./node_modules/core-js/modules/es6.reflect.define-property.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(/*! core-js/modules/es6.reflect.delete-property */ "./node_modules/core-js/modules/es6.reflect.delete-property.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_reflect_get__ = __webpack_require__(/*! core-js/modules/es6.reflect.get */ "./node_modules/core-js/modules/es6.reflect.get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(/*! core-js/modules/es6.reflect.get-own-property-descriptor */ "./node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.reflect.get-prototype-of */ "./node_modules/core-js/modules/es6.reflect.get-prototype-of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es6_reflect_has__ = __webpack_require__(/*! core-js/modules/es6.reflect.has */ "./node_modules/core-js/modules/es6.reflect.has.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(/*! core-js/modules/es6.reflect.is-extensible */ "./node_modules/core-js/modules/es6.reflect.is-extensible.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(/*! core-js/modules/es6.reflect.own-keys */ "./node_modules/core-js/modules/es6.reflect.own-keys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(/*! core-js/modules/es6.reflect.prevent-extensions */ "./node_modules/core-js/modules/es6.reflect.prevent-extensions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es6_reflect_set__ = __webpack_require__(/*! core-js/modules/es6.reflect.set */ "./node_modules/core-js/modules/es6.reflect.set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.reflect.set-prototype-of */ "./node_modules/core-js/modules/es6.reflect.set-prototype-of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_es6_regexp_constructor__ = __webpack_require__(/*! core-js/modules/es6.regexp.constructor */ "./node_modules/core-js/modules/es6.regexp.constructor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_es6_regexp_constructor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_core_js_modules_es6_regexp_constructor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_es6_regexp_flags__ = __webpack_require__(/*! core-js/modules/es6.regexp.flags */ "./node_modules/core-js/modules/es6.regexp.flags.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_core_js_modules_es6_regexp_match__ = __webpack_require__(/*! core-js/modules/es6.regexp.match */ "./node_modules/core-js/modules/es6.regexp.match.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_core_js_modules_es6_regexp_replace__ = __webpack_require__(/*! core-js/modules/es6.regexp.replace */ "./node_modules/core-js/modules/es6.regexp.replace.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_core_js_modules_es6_regexp_split__ = __webpack_require__(/*! core-js/modules/es6.regexp.split */ "./node_modules/core-js/modules/es6.regexp.split.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_core_js_modules_es6_regexp_search__ = __webpack_require__(/*! core-js/modules/es6.regexp.search */ "./node_modules/core-js/modules/es6.regexp.search.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_core_js_modules_es6_regexp_to_string__ = __webpack_require__(/*! core-js/modules/es6.regexp.to-string */ "./node_modules/core-js/modules/es6.regexp.to-string.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_core_js_modules_es6_regexp_to_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100_core_js_modules_es6_regexp_to_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_core_js_modules_es6_set__ = __webpack_require__(/*! core-js/modules/es6.set */ "./node_modules/core-js/modules/es6.set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_core_js_modules_es6_symbol__ = __webpack_require__(/*! core-js/modules/es6.symbol */ "./node_modules/core-js/modules/es6.symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_core_js_modules_es7_symbol_async_iterator__ = __webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */ "./node_modules/core-js/modules/es7.symbol.async-iterator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_core_js_modules_es7_symbol_async_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103_core_js_modules_es7_symbol_async_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_core_js_modules_es6_string_anchor__ = __webpack_require__(/*! core-js/modules/es6.string.anchor */ "./node_modules/core-js/modules/es6.string.anchor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_core_js_modules_es6_string_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104_core_js_modules_es6_string_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_core_js_modules_es6_string_big__ = __webpack_require__(/*! core-js/modules/es6.string.big */ "./node_modules/core-js/modules/es6.string.big.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_core_js_modules_es6_string_big___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105_core_js_modules_es6_string_big__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_core_js_modules_es6_string_blink__ = __webpack_require__(/*! core-js/modules/es6.string.blink */ "./node_modules/core-js/modules/es6.string.blink.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_core_js_modules_es6_string_blink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106_core_js_modules_es6_string_blink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_core_js_modules_es6_string_bold__ = __webpack_require__(/*! core-js/modules/es6.string.bold */ "./node_modules/core-js/modules/es6.string.bold.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_core_js_modules_es6_string_bold___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107_core_js_modules_es6_string_bold__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_core_js_modules_es6_string_code_point_at__ = __webpack_require__(/*! core-js/modules/es6.string.code-point-at */ "./node_modules/core-js/modules/es6.string.code-point-at.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_core_js_modules_es6_string_ends_with__ = __webpack_require__(/*! core-js/modules/es6.string.ends-with */ "./node_modules/core-js/modules/es6.string.ends-with.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110_core_js_modules_es6_string_fixed__ = __webpack_require__(/*! core-js/modules/es6.string.fixed */ "./node_modules/core-js/modules/es6.string.fixed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110_core_js_modules_es6_string_fixed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110_core_js_modules_es6_string_fixed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111_core_js_modules_es6_string_fontcolor__ = __webpack_require__(/*! core-js/modules/es6.string.fontcolor */ "./node_modules/core-js/modules/es6.string.fontcolor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111_core_js_modules_es6_string_fontcolor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111_core_js_modules_es6_string_fontcolor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112_core_js_modules_es6_string_fontsize__ = __webpack_require__(/*! core-js/modules/es6.string.fontsize */ "./node_modules/core-js/modules/es6.string.fontsize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112_core_js_modules_es6_string_fontsize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112_core_js_modules_es6_string_fontsize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113_core_js_modules_es6_string_from_code_point__ = __webpack_require__(/*! core-js/modules/es6.string.from-code-point */ "./node_modules/core-js/modules/es6.string.from-code-point.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114_core_js_modules_es6_string_includes__ = __webpack_require__(/*! core-js/modules/es6.string.includes */ "./node_modules/core-js/modules/es6.string.includes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115_core_js_modules_es6_string_italics__ = __webpack_require__(/*! core-js/modules/es6.string.italics */ "./node_modules/core-js/modules/es6.string.italics.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115_core_js_modules_es6_string_italics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115_core_js_modules_es6_string_italics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116_core_js_modules_es6_string_iterator__ = __webpack_require__(/*! core-js/modules/es6.string.iterator */ "./node_modules/core-js/modules/es6.string.iterator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116_core_js_modules_es6_string_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116_core_js_modules_es6_string_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117_core_js_modules_es6_string_link__ = __webpack_require__(/*! core-js/modules/es6.string.link */ "./node_modules/core-js/modules/es6.string.link.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117_core_js_modules_es6_string_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117_core_js_modules_es6_string_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118_core_js_modules_es7_string_pad_start__ = __webpack_require__(/*! core-js/modules/es7.string.pad-start */ "./node_modules/core-js/modules/es7.string.pad-start.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119_core_js_modules_es7_string_pad_end__ = __webpack_require__(/*! core-js/modules/es7.string.pad-end */ "./node_modules/core-js/modules/es7.string.pad-end.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120_core_js_modules_es6_string_raw__ = __webpack_require__(/*! core-js/modules/es6.string.raw */ "./node_modules/core-js/modules/es6.string.raw.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121_core_js_modules_es6_string_repeat__ = __webpack_require__(/*! core-js/modules/es6.string.repeat */ "./node_modules/core-js/modules/es6.string.repeat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122_core_js_modules_es6_string_small__ = __webpack_require__(/*! core-js/modules/es6.string.small */ "./node_modules/core-js/modules/es6.string.small.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122_core_js_modules_es6_string_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122_core_js_modules_es6_string_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123_core_js_modules_es6_string_starts_with__ = __webpack_require__(/*! core-js/modules/es6.string.starts-with */ "./node_modules/core-js/modules/es6.string.starts-with.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124_core_js_modules_es6_string_strike__ = __webpack_require__(/*! core-js/modules/es6.string.strike */ "./node_modules/core-js/modules/es6.string.strike.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124_core_js_modules_es6_string_strike___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124_core_js_modules_es6_string_strike__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125_core_js_modules_es6_string_sub__ = __webpack_require__(/*! core-js/modules/es6.string.sub */ "./node_modules/core-js/modules/es6.string.sub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125_core_js_modules_es6_string_sub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125_core_js_modules_es6_string_sub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126_core_js_modules_es6_string_sup__ = __webpack_require__(/*! core-js/modules/es6.string.sup */ "./node_modules/core-js/modules/es6.string.sup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126_core_js_modules_es6_string_sup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126_core_js_modules_es6_string_sup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127_core_js_modules_es6_string_trim__ = __webpack_require__(/*! core-js/modules/es6.string.trim */ "./node_modules/core-js/modules/es6.string.trim.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127_core_js_modules_es6_string_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127_core_js_modules_es6_string_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(/*! core-js/modules/es6.typed.array-buffer */ "./node_modules/core-js/modules/es6.typed.array-buffer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129_core_js_modules_es6_typed_data_view__ = __webpack_require__(/*! core-js/modules/es6.typed.data-view */ "./node_modules/core-js/modules/es6.typed.data-view.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129_core_js_modules_es6_typed_data_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129_core_js_modules_es6_typed_data_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130_core_js_modules_es6_typed_int8_array__ = __webpack_require__(/*! core-js/modules/es6.typed.int8-array */ "./node_modules/core-js/modules/es6.typed.int8-array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint8-array */ "./node_modules/core-js/modules/es6.typed.uint8-array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint8-clamped-array */ "./node_modules/core-js/modules/es6.typed.uint8-clamped-array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133_core_js_modules_es6_typed_int16_array__ = __webpack_require__(/*! core-js/modules/es6.typed.int16-array */ "./node_modules/core-js/modules/es6.typed.int16-array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint16-array */ "./node_modules/core-js/modules/es6.typed.uint16-array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135_core_js_modules_es6_typed_int32_array__ = __webpack_require__(/*! core-js/modules/es6.typed.int32-array */ "./node_modules/core-js/modules/es6.typed.int32-array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint32-array */ "./node_modules/core-js/modules/es6.typed.uint32-array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137_core_js_modules_es6_typed_float32_array__ = __webpack_require__(/*! core-js/modules/es6.typed.float32-array */ "./node_modules/core-js/modules/es6.typed.float32-array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138_core_js_modules_es6_typed_float64_array__ = __webpack_require__(/*! core-js/modules/es6.typed.float64-array */ "./node_modules/core-js/modules/es6.typed.float64-array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139_core_js_modules_es6_weak_map__ = __webpack_require__(/*! core-js/modules/es6.weak-map */ "./node_modules/core-js/modules/es6.weak-map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140_core_js_modules_es6_weak_set__ = __webpack_require__(/*! core-js/modules/es6.weak-set */ "./node_modules/core-js/modules/es6.weak-set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141_core_js_modules_web_timers__ = __webpack_require__(/*! core-js/modules/web.timers */ "./node_modules/core-js/modules/web.timers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142_core_js_modules_web_immediate__ = __webpack_require__(/*! core-js/modules/web.immediate */ "./node_modules/core-js/modules/web.immediate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143_core_js_modules_web_dom_iterable__ = __webpack_require__(/*! core-js/modules/web.dom.iterable */ "./node_modules/core-js/modules/web.dom.iterable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144_regenerator_runtime_runtime__ = __webpack_require__(/*! regenerator-runtime/runtime */ "./node_modules/regenerator-runtime/runtime.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145_whatwg_fetch__ = __webpack_require__(/*! whatwg-fetch */ "./node_modules/whatwg-fetch/fetch.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146_intersection_observer__ = __webpack_require__(/*! intersection-observer */ "./node_modules/intersection-observer/intersection-observer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146_intersection_observer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147_smoothscroll_polyfill__ = __webpack_require__(/*! smoothscroll-polyfill */ "./node_modules/smoothscroll-polyfill/dist/smoothscroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147_smoothscroll_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147_smoothscroll_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148_objectFitPolyfill__ = __webpack_require__(/*! objectFitPolyfill */ "./node_modules/objectFitPolyfill/dist/objectFitPolyfill.min.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148_objectFitPolyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148_objectFitPolyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__styles_main_scss__ = __webpack_require__(/*! ~/styles/main.scss */ "./public/assets/styles/main.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149__styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__bootstrap__ = __webpack_require__(/*! ./bootstrap */ "./public/assets/scripts/bootstrap.js");





















































































































































__WEBPACK_IMPORTED_MODULE_147_smoothscroll_polyfill___default.a.polyfill();
objectFitPolyfill();


Object(__WEBPACK_IMPORTED_MODULE_150__bootstrap__["a" /* default */])();

/***/ }),

/***/ "./public/assets/styles/main.scss":
/*!****************************************!*\
  !*** ./public/assets/styles/main.scss ***!
  \****************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/*!*********************************************!*\
  !*** multi ./public/assets/scripts/main.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./public/assets/scripts/main.js */"./public/assets/scripts/main.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// main.8bfab214.js